// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { useNavigate, useParams } from "react-router-dom";

// // ── Import your actual assets ──────────────────────────────────────────────
// import Mangalya from "../../assets/images/HomeDesk/events/newsAnnouncement/images/Mangalya.png";
// import image1 from "../../assets/images/HomeDesk/events/newsAnnouncement/images/WomensDay-1.jpg";
// import image2 from "../../assets/images/HomeDesk/events/newsAnnouncement/images/Womens_Day-2.jpg";
// import PhD from "../../assets/pdf/NewsAnnouncement/List of Students selected for PhD Admission 2021-2022.pdf";
// import NationalConferences from "../../assets/pdf/UpcomingEvent/MIBM_National_Conference.pdf";
// import FRA from "../../assets/pdf/NoticeBoard/FRA Fees Proposal.pdf";
// import Orientation from "../../assets/pdf/NoticeBoard/MIBM_Orientation_Program_2023_24.pdf";
// import Online_registration from "../../assets/pdf/NoticeBoard/Online_registration_of_application.pdf";
// import AdmissionEnquiry from "../../assets/pdf/NoticeBoard/AdmissionEnquiry.pdf";
// import AdmissionBrochure from "../../assets/pdf/NoticeBoard/AdmissionBrochoure-2023-24.pdf";
// import Breadcrumb from "../../Components/Breadcrumb";
// import AnnouncementIcon from "@mui/icons-material/Announcement";
// import EventIcon from "@mui/icons-material/Event";
// import AssignmentIcon from "@mui/icons-material/Assignment";

// import placementBrochure1 from "../../assets/pdf/Event/Final placement brochure.pdf";
// import admissionBrochure2 from "../../assets/pdf/Event/MIBM 7 x 7 brochure (1).pdf";

// import d1 from "../../assets/images/HomeDesk/events/Darpan/APP_1300.JPG";
// import d2 from "../../assets/images/HomeDesk/events/Darpan/APP_1302.JPG";
// import d3 from "../../assets/images/HomeDesk/events/Darpan/APP_1303.JPG";
// import d4 from "../../assets/images/HomeDesk/events/Darpan/APP_1307.JPG";
// import d5 from "../../assets/images/HomeDesk/events/Darpan/APP_1331.JPG";
// import d6 from "../../assets/images/HomeDesk/events/Darpan/APP_1335.JPG";
// import d7 from "../../assets/images/HomeDesk/events/Darpan/APP_1359.JPG";
// import d8 from "../../assets/images/HomeDesk/events/Darpan/APP_1364.JPG";
// import d9 from "../../assets/images/HomeDesk/events/Darpan/APP_1393.JPG";
// import d10 from "../../assets/images/HomeDesk/events/Darpan/APP_1409.JPG";
// import d11 from "../../assets/images/HomeDesk/events/Darpan/APP_1427.JPG";
// import d12 from "../../assets/images/HomeDesk/events/Darpan/APP_1433.JPG";
// import d13 from "../../assets/images/HomeDesk/events/Darpan/APP_1438.JPG";
// import d14 from "../../assets/images/HomeDesk/events/Darpan/APP_1443.JPG";
// import d15 from "../../assets/images/HomeDesk/events/Darpan/APP_1460.JPG";
// import d16 from "../../assets/images/HomeDesk/events/Darpan/APP_1462.JPG";
// import d17 from "../../assets/images/HomeDesk/events/Darpan/APP_1469.JPG";
// import d18 from "../../assets/images/HomeDesk/events/Darpan/APP_1493.JPG";
// import d19 from "../../assets/images/HomeDesk/events/Darpan/APP_1595.JPG";
// import d20 from "../../assets/images/HomeDesk/events/Darpan/APP_1601.JPG";
// import d21 from "../../assets/images/HomeDesk/events/Darpan/APP_1605.JPG";
// import d22 from "../../assets/images/HomeDesk/events/Darpan/APP_1612.JPG";
// import d23 from "../../assets/images/HomeDesk/events/Darpan/APP_1626.JPG";
// import d24 from "../../assets/images/HomeDesk/events/Darpan/APP_1643.JPG";
// import d25 from "../../assets/images/HomeDesk/events/Darpan/APP_1650.JPG";
// import d26 from "../../assets/images/HomeDesk/events/Darpan/APP_1681.JPG";
// import d27 from "../../assets/images/HomeDesk/events/Darpan/APP_1689.JPG";
// import d28 from "../../assets/images/HomeDesk/events/Darpan/APP_1704.JPG";
// import d29 from "../../assets/images/HomeDesk/events/Darpan/APP_1743.JPG";
// import d30 from "../../assets/images/HomeDesk/events/Darpan/APP_1748.JPG";
// import d31 from "../../assets/images/HomeDesk/events/Darpan/APP_1768.JPG";
// import d32 from "../../assets/images/HomeDesk/events/Darpan/APP_1776.JPG";
// import d33 from "../../assets/images/HomeDesk/events/Darpan/APP_1777.JPG";
// import d34 from "../../assets/images/HomeDesk/events/Darpan/APP_1809.JPG";
// import d35 from "../../assets/images/HomeDesk/events/Darpan/APP_1812.JPG";
// import d36 from "../../assets/images/HomeDesk/events/Darpan/APP_1822.JPG";
// import d37 from "../../assets/images/HomeDesk/events/Darpan/Darpan 2025.JPG";

// // ── Mangalya images ────────────────────────────────────────────────────────
// import m1 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0325.JPG";
// import m2 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0345.JPG";
// import m3 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0350.JPG";
// import m4 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0394.JPG";
// import m5 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0405.JPG";
// import m6 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0417.JPG";
// import m7 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0522.JPG";
// import m8 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0602.JPG";
// import m9 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0605.JPG";
// import m10 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0611.JPG";
// import m11 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0743.JPG";
// import m12 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0747.JPG";
// import m13 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0774.JPG";
// import m14 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0775.JPG";
// import m15 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0807.JPG";
// import m16 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0841.JPG";
// import m17 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0863.JPG";
// import m18 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0868.JPG";
// import m19 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0875.JPG";
// import m20 from "../../assets/images/HomeDesk/events/Mangalya/IMG_4373.JPG";
// import m21 from "../../assets/images/HomeDesk/events/Mangalya/IMG_4391.JPG";
// import m22 from "../../assets/images/HomeDesk/events/Mangalya/Mangalya 2025.JPG";
// import m23 from "../../assets/images/HomeDesk/events/Mangalya/MVI_0361.MP4";

// // ── All data combined ──────────────────────────────────────────────────────
// export const allEventsData = [
//   {
//     id: "Mangalya",
//     order: 1,
//     category: "news",
//     title: "Mangalya 9.0",
//     cardImage: Mangalya,
//     images: [m1,m2,m3,m4,m5,m6,m7,m8,m9,m10,m11,m12,m13,m14,m15,m16,m17,m18,m19,m20,m21,m22],
//     pdfs: [],
//     video: [m23],
//     link: "https://youtu.be/8GScjZAb2e8",
//     description: `Mangalya 9.0 started on 28th Feb and 29th Feb 2024 with huge participation.
//     It was inaugurated by Prof.Dr.Nivedita Ekbote coordinator and Prof.Dr.Vijayalaxmi Srinivas,
//     Director of PES Modern Institute of Business Management.
//     The Rocking Flash Mob of our students was the point of attraction at inauguration.
//     Mangalya is the flagship management event of MIBM which consists of management games,
//     sports and most importantly is enormous fun.`,
//     updatedDate: "Updated on 15 April 2024",
//   },
//   {
//     id: "PhD",
//     order: 6,
//     category: "news",
//     title: "Ph.D Interviews",
//     cardImage: null,
//     images: [],
//     pdfs: [PhD],
//     video: null,
//     link: null,
//     description: "",
//     updatedDate: "Updated on 19 May 2023",
//   },
//   {
//     id: "WomensDay",
//     order: 2,
//     category: "news",
//     title: "International Women's Day at MIBM",
//     cardImage: image1,
//     images: [image1, image2],
//     pdfs: [],
//     video: null,
//     link: null,
//     description:
//       "We had entrepreneurs, sportswomen, Chatrapati awardee and founders of Alacrity Gymnastics Academy, Madhura Tambe and Kalyani Tambe. The program started with a beautiful demo of gymnastics of their student and a national player.",
//     updatedDate: "Updated on 8 Mar 2022",
//   },
//   {
//     id: "fee-fixation-2025",
//     category: "notice",
//     order: 8,
//     title: "Fee Fixation Proposal A.Y. 2025-26",
//     cardImage: null,
//     images: [],
//     pdfs: [FRA],
//     video: null,
//     link: null,
//     description: "",
//     updatedDate: "Updated on 28 June 2023",
//   },
//   {
//     id: "orientation-mba-2023",
//     category: "notice",
//     order: 5,
//     title: "Orientation Programme MBA | A.Y 2023-24",
//     cardImage: null,
//     images: [],
//     pdfs: [Orientation],
//     video: null,
//     link: null,
//     description: "",
//     updatedDate: "Updated on 28 June 2023",
//   },
//   {
//     id: "online-registration-2023",
//     category: "notice",
//     order: 10,
//     title: "Online Registration of Application",
//     cardImage: null,
//     images: [],
//     pdfs: [Online_registration],
//     video: null,
//     link: null,
//     blinking: true,
//     description:
//       "Online registration of application and uploading of required documents by the Candidate for admission on the website from 28/06/2023 to 07-07-2023.",
//     updatedDate: "Updated on 28 June 2023",
//   },
//   {
//     id: "admission-enquiry",
//     category: "notice",
//     order: 11,
//     title: "MIBM Admission Enquiry",
//     cardImage: null,
//     images: [],
//     pdfs: [AdmissionEnquiry],
//     video: null,
//     link: null,
//     blinking: true,
//     description: "",
//     updatedDate: "Updated on 14 March 2023",
//   },
//   {
//     id: "admission-brochure-2023",
//     category: "notice",
//     order: 9,
//     title: "MBA Admission Brochure",
//     cardImage: null,
//     images: [],
//     pdfs: [admissionBrochure2],
//     video: null,
//     link: null,
//     blinking: true,
//     description: "",
//     updatedDate: "",
//   },
//   {
//     id: "placement-brochure",
//     category: "event",
//     order: 7,
//     title: "Placement Brochure",
//     cardImage: null,
//     images: [],
//     pdfs: [placementBrochure1],
//     video: null,
//     link: null,
//     description: "",
//     updatedDate: "Upcoming on 27 May 2023",
//     date: 27,
//   },
//   {
//     id: "darpan-2023",
//     order: 3,
//     category: "event",
//     title: "Darpan - Cultural Fest 2023",
//     cardImage: "/assets/images/logo/DARPAN CULTURAL FEST 2025 (1).JPG",
//     images: [d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13, d14, d15, d16, d17, d18, d19, d20, d21, d22, d23, d24, d25, d26, d27, d28, d29, d30, d31, d32, d33, d34, d35, d36, d37],
//     pdfs: [],
//     video: null,
//     link: null,
//     description: "PES MIBM organizes Darpan - Cultural Fest on Monday, 29th May 2023.",
//     updatedDate: "Upcoming on 29 May 2023",
//     date: 24,
//   },
//   {
//     id: "national-conference-2023",
//     category: "event",
//     order: 4,
//     title: "MIBM National Conference",
//     cardImage: null,
//     images: [],
//     pdfs: [NationalConferences],
//     video: null,
//     link: null,
//     description:
//       'MIBM is organizing 9th National conference on the theme "National Education Policy – Role of Behavioral Sciences in Management and Implementation of Multidisciplinary Education".',
//     updatedDate: "Upcoming on 6 & 7 January 2023",
//     date: "6 & 7",
//   },
// ];

// // ── Constants ──────────────────────────────────────────────────────────────
// const BRAND = "#a70606";

// const categoryConfig = {
//   news: {
//     label: "News",
//     emoji: <AnnouncementIcon sx={{ color: BRAND, fontSize: 50 }} />,
//   },
//   notice: {
//     label: "Notice",
//     emoji: <AssignmentIcon sx={{ color: BRAND, fontSize: 50 }} />,
//   },
//   event: {
//     label: "Event",
//     emoji: <EventIcon sx={{ color: BRAND, fontSize: 50 }} />,
//   },
// };

// // ── Global styles ──────────────────────────────────────────────────────────
// const globalStyles = `
//   @keyframes blinkAnimation {
//     0%   { opacity: 1; }
//     50%  { opacity: 0.2; }
//     100% { opacity: 1; }
//   }

//   @keyframes shimmer {
//     0%   { background-position: -600px 0; }
//     100% { background-position: 600px 0; }
//   }

//   @keyframes fadeIn {
//     from { opacity: 0; transform: translateY(6px); }
//     to   { opacity: 1; transform: translateY(0); }
//   }

//   .skeleton {
//     background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//     background-size: 600px 100%;
//     animation: shimmer 1.4s infinite linear;
//     border-radius: 8px;
//   }

//   .img-fade-in {
//     animation: fadeIn 0.4s ease forwards;
//   }

//   .event-card {
//     transition: transform 0.22s ease, box-shadow 0.22s ease;
//   }
//   .event-card:hover {
//     transform: translateY(-5px);
//     box-shadow: 0 10px 28px rgba(0,0,0,0.15) !important;
//   }
// `;

// // ── LazyImage — skeleton + blur-up + lazy load ─────────────────────────────
// /**
//  * Props:
//  *  src, alt, style, containerStyle, aspectRatio (default "4/3")
//  */
// const LazyImage = ({ src, alt, style = {}, containerStyle = {}, aspectRatio = "auto" }) => {
//   const [status, setStatus] = useState("idle"); // idle | loading | loaded | error
//   const imgRef = useRef(null);
//   const observerRef = useRef(null);

//   const startLoad = useCallback(() => {
//     if (status !== "idle") return;
//     setStatus("loading");
//     const img = new Image();
//     img.src = src;
//     img.onload = () => setStatus("loaded");
//     img.onerror = () => setStatus("error");
//   }, [src, status]);

//   useEffect(() => {
//     if (!imgRef.current) return;
//     observerRef.current = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           startLoad();
//           observerRef.current?.disconnect();
//         }
//       },
//       { rootMargin: "300px 0px" } // preload 300px before entering viewport
//     );
//     observerRef.current.observe(imgRef.current);
//     return () => observerRef.current?.disconnect();
//   }, [startLoad]);

//   return (
//     <div
//       ref={imgRef}
//       style={{
//         position: "relative",
//         overflow: "hidden",
//         aspectRatio,
//         background: "#f0f0f0",
//         borderRadius: style.borderRadius || 0,
//         ...containerStyle,
//       }}
//     >
//       {/* Skeleton shown while idle or loading */}
//       {status !== "loaded" && status !== "error" && (
//         <div
//           className="skeleton"
//           style={{ position: "absolute", inset: 0, borderRadius: 0 }}
//         />
//       )}

//       {/* Error state */}
//       {status === "error" && (
//         <div
//           style={{
//             position: "absolute",
//             inset: 0,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             color: "#bbb",
//             fontSize: 13,
//             flexDirection: "column",
//             gap: 6,
//           }}
//         >
//           <span style={{ fontSize: 26 }}>🖼️</span>
//           <span>Image unavailable</span>
//         </div>
//       )}

//       {/* Actual image — hidden until loaded */}
//       {(status === "loading" || status === "loaded") && (
//         <img
//           src={src}
//           alt={alt}
//           loading="lazy"
//           decoding="async"
//           className={status === "loaded" ? "img-fade-in" : ""}
//           style={{
//             position: "absolute",
//             inset: 0,
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             display: "block",
//             opacity: status === "loaded" ? 1 : 0,
//             transition: "opacity 0.4s ease",
//             filter: status === "loaded" ? "none" : "blur(8px)",
//             ...style,
//           }}
//         />
//       )}
//     </div>
//   );
// };

// // ── CardImage — card-sized lazy image with skeleton ────────────────────────
// const CardImage = ({ src, alt }) => (
//   <LazyImage
//     src={src}
//     alt={alt}
//     aspectRatio="auto"
//     containerStyle={{ height: 145, width: "100%" }}
//     style={{ borderRadius: 0 }}
//   />
// );

// // ── HOME SECTION ───────────────────────────────────────────────────────────
// export const AllEventsSection = () => {
//   const navigate = useNavigate();
//   const [filter, setFilter] = useState("all");

//   const filtered =
//     filter === "all"
//       ? [...allEventsData].sort((a, b) => a.order - b.order)
//       : allEventsData
//           .filter((d) => d.category === filter)
//           .sort((a, b) => a.order - b.order);

//   return (
//     <div style={{ padding: "32px 70px" }}>
//       <style>{globalStyles}</style>

//       {/* Filter tabs */}
//       <div
//         style={{
//           display: "flex",
//           gap: 10,
//           marginBottom: 24,
//           flexWrap: "wrap",
//           justifyContent: "center",
//         }}
//       >
//         {["all", "news", "notice", "event"].map((tab) => (
//           <button
//             key={tab}
//             onClick={() => setFilter(tab)}
//             style={{
//               padding: "7px 22px",
//               borderRadius: 20,
//               border: `2px solid ${BRAND}`,
//               cursor: "pointer",
//               fontWeight: 600,
//               fontSize: 13,
//               textTransform: "capitalize",
//               background: filter === tab ? BRAND : "#fff",
//               color: filter === tab ? "#fff" : BRAND,
//               transition: "all 0.2s",
//             }}
//           >
//             {tab === "all" ? "All" : categoryConfig[tab].label}
//           </button>
//         ))}
//       </div>

//       {/* Cards grid */}
//       <div
//         style={{
//           display: "flex",
//           flexWrap: "wrap",
//           gap: 20,
//           justifyContent: "center",
//         }}
//       >
//         {filtered.map((item) => {
//           const conf = categoryConfig[item.category];
//           return (
//             <div
//               key={item.id}
//               className="event-card"
//               onClick={() => navigate(`/EventDetail/${item.id}`)}
//               style={{
//                 width: 210,
//                 borderRadius: 14,
//                 overflow: "hidden",
//                 background: "#fff",
//                 boxShadow: "0 2px 12px rgba(0,0,0,0.09)",
//                 cursor: "pointer",
//                 flexShrink: 0,
//               }}
//             >
//               {/* Card image or placeholder */}
//               {item.cardImage ? (
//                 <CardImage src={item.cardImage} alt={item.title} />
//               ) : (
//                 <div
//                   style={{
//                     height: 145,
//                     background: "transparent",
//                     border: `1px solid ${BRAND}`,
//                     borderRadius: 16,
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     gap: 8,
//                   }}
//                 >
//                   <span style={{ fontSize: 44, marginBottom: 20 }}>{conf.emoji}</span>
//                   {item.pdfs?.length > 0 && (
//                     <span style={{ color: BRAND, fontSize: 11 }}>PDF</span>
//                   )}
//                   {isYouTubeLink(item.link) && (
//                     <span style={{ color: BRAND, fontSize: 11 }}>Video</span>
//                   )}
//                   {!item.pdfs?.length && !isYouTubeLink(item.link) && (
//                     <span style={{ color: BRAND, fontSize: 11 }}>Click to see</span>
//                   )}
//                 </div>
//               )}

//               {/* Card content */}
//               <div style={{ padding: "12px 14px 14px" }}>
//                 <span
//                   style={{
//                     display: "inline-block",
//                     fontSize: 10,
//                     fontWeight: 700,
//                     textTransform: "uppercase",
//                     letterSpacing: 0.8,
//                     background: BRAND,
//                     color: "#fff",
//                     borderRadius: 4,
//                     padding: "2px 8px",
//                     marginBottom: 8,
//                   }}
//                 >
//                   {conf.label}
//                 </span>

//                 <p
//                   style={{
//                     margin: "0 0 6px",
//                     fontWeight: 700,
//                     fontSize: 14,
//                     color: item.blinking ? BRAND : "#1a1a1a",
//                     lineHeight: 1.35,
//                     display: "-webkit-box",
//                     WebkitLineClamp: 2,
//                     WebkitBoxOrient: "vertical",
//                     overflow: "hidden",
//                     animation: item.blinking ? "blinkAnimation 1s ease-in infinite" : "none",
//                   }}
//                 >
//                   {item.title}
//                 </p>

//                 <p style={{ margin: 0, fontSize: 11, color: "#999" }}>
//                   {item.updatedDate}
//                 </p>

//                 <div style={{ marginTop: 10, color: BRAND, fontSize: 12, fontWeight: 600 }}>
//                   View Details →
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// // ── Helpers ────────────────────────────────────────────────────────────────
// const isYouTubeLink = (url) =>
//   url && (url.includes("youtube.com") || url.includes("youtu.be"));

// const getYouTubeEmbedUrl = (url) => {
//   if (!url) return null;
//   const shortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
//   if (shortMatch) return `https://www.youtube.com/embed/${shortMatch[1]}`;
//   const longMatch = url.match(/[?&]v=([a-zA-Z0-9_-]+)/);
//   if (longMatch) return `https://www.youtube.com/embed/${longMatch[1]}`;
//   return null;
// };

// // ── Section wrapper ────────────────────────────────────────────────────────
// const Section = ({ title, children }) => (
//   <div
//     style={{
//       background: "#fff",
//       borderRadius: 14,
//       padding: 24,
//       marginBottom: 20,
//       boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
//     }}
//   >
//     <h3
//       style={{
//         margin: "0 0 16px",
//         fontSize: 15,
//         fontWeight: 700,
//         color: "#555",
//         textTransform: "uppercase",
//         letterSpacing: 0.5,
//         borderBottom: "2px solid #f0f0f0",
//         paddingBottom: 10,
//       }}
//     >
//       {title}
//     </h3>
//     {children}
//   </div>
// );

// // ── GalleryGrid — virtualized lazy gallery with lightbox ───────────────────
// const GalleryGrid = ({ images, onOpen }) => {
//   // Stagger-load: reveal items progressively as they enter view
//   return (
//     <div
//       style={{
//         display: "grid",
//         gridTemplateColumns:
//           images.length === 1
//             ? "1fr"
//             : "repeat(auto-fill, minmax(220px, 1fr))",
//         gap: 12,
//       }}
//     >
//       {images.map((img, i) => (
//         <GalleryItem key={i} src={img} index={i} onOpen={onOpen} />
//       ))}
//     </div>
//   );
// };

// const GalleryItem = ({ src, index, onOpen }) => {
//   const [hovered, setHovered] = useState(false);

//   return (
//     <div
//       onClick={() => onOpen(src)}
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//       style={{
//         borderRadius: 10,
//         overflow: "hidden",
//         cursor: "zoom-in",
//         aspectRatio: "4/3",
//         background: "#ddd",
//         // Stagger card reveal based on index
//         animation: `fadeIn 0.35s ease ${Math.min(index * 0.04, 0.6)}s both`,
//       }}
//     >
//       <LazyImage
//         src={src}
//         alt={`Gallery image ${index + 1}`}
//         aspectRatio="4/3"
//         containerStyle={{ height: "100%", width: "100%", borderRadius: 0 }}
//         style={{
//           transform: hovered ? "scale(1.05)" : "scale(1)",
//           transition: "transform 0.3s ease",
//           borderRadius: 0,
//         }}
//       />
//     </div>
//   );
// };

// // ── Lightbox ───────────────────────────────────────────────────────────────
// const Lightbox = ({ images, currentIndex, onClose, onPrev, onNext }) => {
//   const [imgLoaded, setImgLoaded] = useState(false);

//   // Reset loaded state when image changes
//   useEffect(() => {
//     setImgLoaded(false);
//   }, [currentIndex]);

//   // Keyboard navigation
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//       if (e.key === "ArrowRight") onNext();
//       if (e.key === "ArrowLeft") onPrev();
//     };
//     window.addEventListener("keydown", handler);
//     return () => window.removeEventListener("keydown", handler);
//   }, [onClose, onNext, onPrev]);

//   const src = images[currentIndex];
//   const hasMultiple = images.length > 1;

//   return (
//     <div
//       onClick={onClose}
//       style={{
//         position: "fixed",
//         inset: 0,
//         background: "rgba(0,0,0,0.93)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 9999,
//         cursor: "zoom-out",
//         animation: "fadeIn 0.2s ease",
//       }}
//     >
//       {/* Prev button */}
//       {hasMultiple && (
//         <button
//           onClick={(e) => { e.stopPropagation(); onPrev(); }}
//           style={navBtnStyle("left")}
//           aria-label="Previous"
//         >
//           ‹
//         </button>
//       )}

//       {/* Image container */}
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           position: "relative",
//           maxWidth: "88vw",
//           maxHeight: "88vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         {/* Skeleton while full image loads */}
//         {!imgLoaded && (
//           <div
//             className="skeleton"
//             style={{ width: "60vw", height: "60vh", borderRadius: 12 }}
//           />
//         )}
//         <img
//           key={src}
//           src={src}
//           alt="full"
//           loading="lazy"
//           decoding="async"
//           onLoad={() => setImgLoaded(true)}
//           style={{
//             maxWidth: "88vw",
//             maxHeight: "88vh",
//             borderRadius: 12,
//             objectFit: "contain",
//             display: imgLoaded ? "block" : "none",
//             animation: imgLoaded ? "fadeIn 0.3s ease" : "none",
//             cursor: "default",
//           }}
//         />

//         {/* Counter */}
//         {hasMultiple && imgLoaded && (
//           <div
//             style={{
//               position: "absolute",
//               bottom: -36,
//               left: "50%",
//               transform: "translateX(-50%)",
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 13,
//               whiteSpace: "nowrap",
//             }}
//           >
//             {currentIndex + 1} / {images.length}
//           </div>
//         )}
//       </div>

//       {/* Next button */}
//       {hasMultiple && (
//         <button
//           onClick={(e) => { e.stopPropagation(); onNext(); }}
//           style={navBtnStyle("right")}
//           aria-label="Next"
//         >
//           ›
//         </button>
//       )}

//       {/* Close button */}
//       <button
//         onClick={(e) => { e.stopPropagation(); onClose(); }}
//         style={{
//           position: "absolute",
//           top: 20,
//           right: 24,
//           background: "rgba(255,255,255,0.15)",
//           border: "none",
//           color: "#fff",
//           fontSize: 26,
//           cursor: "pointer",
//           borderRadius: 8,
//           width: 44,
//           height: 44,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           transition: "background 0.2s",
//         }}
//         onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.28)")}
//         onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.15)")}
//       >
//         ✕
//       </button>
//     </div>
//   );
// };

// const navBtnStyle = (side) => ({
//   position: "absolute",
//   [side]: 16,
//   background: "rgba(255,255,255,0.15)",
//   border: "none",
//   color: "#fff",
//   fontSize: 42,
//   cursor: "pointer",
//   borderRadius: 8,
//   width: 52,
//   height: 52,
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   zIndex: 10,
//   lineHeight: 1,
//   transition: "background 0.2s",
// });

// // ── DETAIL PAGE ────────────────────────────────────────────────────────────
// export const EventDetailPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   // Lightbox state — index-based for prev/next navigation
//   const [lightboxIndex, setLightboxIndex] = useState(null);

//   React.useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [id]);

//   const item = allEventsData.find((d) => d.id === id);
//   const hasYouTube = item ? isYouTubeLink(item.link) : false;
//   const embedUrl = hasYouTube ? getYouTubeEmbedUrl(item.link) : null;

//   const openLightbox = useCallback(
//     (src) => {
//       const idx = item.images.indexOf(src);
//       setLightboxIndex(idx >= 0 ? idx : 0);
//     },
//     [item]
//   );

//   const closeLightbox = useCallback(() => setLightboxIndex(null), []);
//   const prevImage = useCallback(
//     () => setLightboxIndex((i) => (i - 1 + item.images.length) % item.images.length),
//     [item]
//   );
//   const nextImage = useCallback(
//     () => setLightboxIndex((i) => (i + 1) % item.images.length),
//     [item]
//   );

//   if (!item) {
//     return (
//       <div style={{ textAlign: "center", padding: 80 }}>
//         <h3>Item not found</h3>
//         <button
//           onClick={() => navigate(-1)}
//           style={{
//             padding: "8px 20px",
//             borderRadius: 8,
//             border: "none",
//             background: BRAND,
//             color: "#fff",
//             cursor: "pointer",
//           }}
//         >
//           ← Go Back
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div style={{ background: "#f5f5f5", minHeight: "100vh" }}>
//       <style>{globalStyles}</style>

//       <div className="bredDivMob">
//         <Breadcrumb
//           pageTitle={
//             <h3 className="fs-3 mt-0 text-bold decorated text-light">
//               {item.title}
//             </h3>
//           }
//         />
//       </div>
//       <div className="bredDivDesk">
//         <Breadcrumb
//           pageTitle={
//             <h3 className="fs-3 mt-0 text-bold decorated text-light">
//               {item.title}
//             </h3>
//           }
//         />
//       </div>

//       <div style={{ padding: "16px 40px 0" }}>
//         <button
//           onClick={() => navigate(-1)}
//           style={{
//             background: BRAND,
//             border: "none",
//             color: "#fff",
//             borderRadius: 8,
//             padding: "7px 18px",
//             cursor: "pointer",
//             fontSize: 13,
//             fontWeight: 600,
//             marginLeft: "100px",
//           }}
//         >
//           ← Back
//         </button>
//       </div>

//       <div style={{ maxWidth: 900, margin: "0 auto", padding: "24px 24px" }}>
//         {/* Videos — shows local video AND/OR YouTube, whichever exist */}
//         {(item.video || (hasYouTube && embedUrl)) && (
//           <Section title="Videos">
//             {/* Local video(s) — supports single src or array */}
//             {item.video && (
//               <div style={{ marginBottom: hasYouTube && embedUrl ? 28 : 0 }}>
//                 <p style={{ margin: "0 0 10px", fontSize: 12, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: 0.6 }}>
//                   📹 Event Recording
//                 </p>
//                 {(Array.isArray(item.video) ? item.video : [item.video]).map((vid, i) => (
//                   <video
//                     key={i}
//                     controls
//                     style={{ width: "100%", borderRadius: 12, background: "#000", maxHeight: 480, marginBottom: 12, display: "block" }}
//                   >
//                     <source src={vid} type="video/mp4" />
//                     Your browser does not support the video tag.
//                   </video>
//                 ))}
//               </div>
//             )}

//             {/* Divider shown only when both exist */}
//             {item.video && hasYouTube && embedUrl && (
//               <div style={{ borderTop: "2px dashed #f0f0f0", margin: "4px 0 28px" }} />
//             )}

//             {/* YouTube embed */}
//             {hasYouTube && embedUrl && (
//               <div>
//                 <p style={{ margin: "0 0 10px", fontSize: 12, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: 0.6 }}>
//                   ▶ YouTube
//                 </p>
//                 <div style={{ borderRadius: 12, overflow: "hidden" }}>
//                   <iframe
//                     width="100%"
//                     height="420"
//                     src={embedUrl}
//                     title={item.title}
//                     frameBorder="0"
//                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                     allowFullScreen
//                     style={{ display: "block" }}
//                   />
//                 </div>
//                 <a
//                   href={item.link}
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{ display: "inline-block", marginTop: 10, color: BRAND, fontSize: 13 }}
//                 >
//                   ▶ Open on YouTube
//                 </a>
//               </div>
//             )}
//           </Section>
//         )}

//         {/* Image Gallery */}
//         {item.images.length > 0 && (
//           <Section title={`Gallery`}>
//             <GalleryGrid images={item.images} onOpen={openLightbox} />
//           </Section>
//         )}

//         {/* Description */}
//         {item.description && (
//           <Section title="About">
//             <p style={{ fontSize: 15, lineHeight: 1.8, color: "#333", margin: 0 }}>
//               {item.description}
//             </p>
//             <p style={{ color: "#a70606" }}>{item.updatedDate ?? item.date}</p>
//           </Section>
//         )}

//         {/* PDF viewer */}
//         {item.pdfs.length > 0 && (
//           <Section title="Documents">
//             {item.pdfs.map((pdf, i) => (
//               <div key={i} style={{ marginBottom: 20 }}>
//                 <div style={{ borderRadius: 12, overflow: "hidden", border: "1px solid #ddd" }}>
//                   <iframe
//                     src={pdf}
//                     width="100%"
//                     height="500"
//                     style={{ display: "block", border: "none" }}
//                     title={`Document ${i + 1}`}
//                   />
//                 </div>
//                 <a
//                   href={pdf}
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     display: "inline-block",
//                     marginTop: 10,
//                     background: BRAND,
//                     color: "#fff",
//                     padding: "8px 20px",
//                     borderRadius: 8,
//                     fontSize: 13,
//                     fontWeight: 600,
//                     textDecoration: "none",
//                   }}
//                 >
//                   📄 Open PDF in new tab
//                 </a>
//               </div>
//             ))}
//           </Section>
//         )}

//         {/* External non-YouTube link */}
//         {item.link && !hasYouTube && (
//           <Section title="Link">
//             <a
//               href={item.link}
//               target="_blank"
//               rel="noreferrer"
//               style={{
//                 display: "inline-block",
//                 background: BRAND,
//                 color: "#fff",
//                 padding: "10px 24px",
//                 borderRadius: 8,
//                 fontSize: 14,
//                 fontWeight: 600,
//                 textDecoration: "none",
//               }}
//             >
//               🔗 Visit Link
//             </a>
//           </Section>
//         )}
//       </div>

//       {/* Enhanced Lightbox */}
//       {lightboxIndex !== null && (
//         <Lightbox
//           images={item.images}
//           currentIndex={lightboxIndex}
//           onClose={closeLightbox}
//           onPrev={prevImage}
//           onNext={nextImage}
//         />
//       )}
//     </div>
//   );
// };

//above is 1st

//below is 2nd

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { useNavigate, useParams } from "react-router-dom";

// // ── Import your actual assets ──────────────────────────────────────────────
// import Mangalya from "../../assets/images/HomeDesk/events/newsAnnouncement/images/Mangalya.png";
// import image1 from "../../assets/images/HomeDesk/events/newsAnnouncement/images/WomensDay-1.jpg";
// import image2 from "../../assets/images/HomeDesk/events/newsAnnouncement/images/Womens_Day-2.jpg";
// import PhD from "../../assets/pdf/NewsAnnouncement/List of Students selected for PhD Admission 2021-2022.pdf";
// import NationalConferences from "../../assets/pdf/UpcomingEvent/MIBM_National_Conference.pdf";
// import FRA from "../../assets/pdf/NoticeBoard/FRA Fees Proposal.pdf";
// import Orientation from "../../assets/pdf/NoticeBoard/MIBM_Orientation_Program_2023_24.pdf";
// import Online_registration from "../../assets/pdf/NoticeBoard/Online_registration_of_application.pdf";
// import AdmissionEnquiry from "../../assets/pdf/NoticeBoard/AdmissionEnquiry.pdf";
// import AdmissionBrochure from "../../assets/pdf/NoticeBoard/AdmissionBrochoure-2023-24.pdf";
// import Breadcrumb from "../../Components/Breadcrumb";
// import AnnouncementIcon from "@mui/icons-material/Announcement";
// import EventIcon from "@mui/icons-material/Event";
// import AssignmentIcon from "@mui/icons-material/Assignment";

// import placementBrochure1 from "../../assets/pdf/Event/Final placement brochure.pdf";
// import admissionBrochure2 from "../../assets/pdf/Event/MIBM 7 x 7 brochure (1).pdf";

// import d1 from "../../assets/images/HomeDesk/events/Darpan/APP_1300.JPG";
// import d2 from "../../assets/images/HomeDesk/events/Darpan/APP_1302.JPG";
// import d3 from "../../assets/images/HomeDesk/events/Darpan/APP_1303.JPG";
// import d4 from "../../assets/images/HomeDesk/events/Darpan/APP_1307.JPG";
// import d5 from "../../assets/images/HomeDesk/events/Darpan/APP_1331.JPG";
// import d6 from "../../assets/images/HomeDesk/events/Darpan/APP_1335.JPG";
// import d7 from "../../assets/images/HomeDesk/events/Darpan/APP_1359.JPG";
// import d8 from "../../assets/images/HomeDesk/events/Darpan/APP_1364.JPG";
// import d9 from "../../assets/images/HomeDesk/events/Darpan/APP_1393.JPG";
// import d10 from "../../assets/images/HomeDesk/events/Darpan/APP_1409.JPG";
// import d11 from "../../assets/images/HomeDesk/events/Darpan/APP_1427.JPG";
// import d12 from "../../assets/images/HomeDesk/events/Darpan/APP_1433.JPG";
// import d13 from "../../assets/images/HomeDesk/events/Darpan/APP_1438.JPG";
// import d14 from "../../assets/images/HomeDesk/events/Darpan/APP_1443.JPG";
// import d15 from "../../assets/images/HomeDesk/events/Darpan/APP_1460.JPG";
// import d16 from "../../assets/images/HomeDesk/events/Darpan/APP_1462.JPG";
// import d17 from "../../assets/images/HomeDesk/events/Darpan/APP_1469.JPG";
// import d18 from "../../assets/images/HomeDesk/events/Darpan/APP_1493.JPG";
// import d19 from "../../assets/images/HomeDesk/events/Darpan/APP_1595.JPG";
// import d20 from "../../assets/images/HomeDesk/events/Darpan/APP_1601.JPG";
// import d21 from "../../assets/images/HomeDesk/events/Darpan/APP_1605.JPG";
// import d22 from "../../assets/images/HomeDesk/events/Darpan/APP_1612.JPG";
// import d23 from "../../assets/images/HomeDesk/events/Darpan/APP_1626.JPG";
// import d24 from "../../assets/images/HomeDesk/events/Darpan/APP_1643.JPG";
// import d25 from "../../assets/images/HomeDesk/events/Darpan/APP_1650.JPG";
// import d26 from "../../assets/images/HomeDesk/events/Darpan/APP_1681.JPG";
// import d27 from "../../assets/images/HomeDesk/events/Darpan/APP_1689.JPG";
// import d28 from "../../assets/images/HomeDesk/events/Darpan/APP_1704.JPG";
// import d29 from "../../assets/images/HomeDesk/events/Darpan/APP_1743.JPG";
// import d30 from "../../assets/images/HomeDesk/events/Darpan/APP_1748.JPG";
// import d31 from "../../assets/images/HomeDesk/events/Darpan/APP_1768.JPG";
// import d32 from "../../assets/images/HomeDesk/events/Darpan/APP_1776.JPG";
// import d33 from "../../assets/images/HomeDesk/events/Darpan/APP_1777.JPG";
// import d34 from "../../assets/images/HomeDesk/events/Darpan/APP_1809.JPG";
// import d35 from "../../assets/images/HomeDesk/events/Darpan/APP_1812.JPG";
// import d36 from "../../assets/images/HomeDesk/events/Darpan/APP_1822.JPG";
// import d37 from "../../assets/images/HomeDesk/events/Darpan/Darpan 2025.JPG";

// // ── Mangalya images ────────────────────────────────────────────────────────
// import m1 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0325.JPG";
// import m2 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0345.JPG";
// import m3 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0350.JPG";
// import m4 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0394.JPG";
// import m5 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0405.JPG";
// import m6 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0417.JPG";
// import m7 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0522.JPG";
// import m8 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0602.JPG";
// import m9 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0605.JPG";
// import m10 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0611.JPG";
// import m11 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0743.JPG";
// import m12 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0747.JPG";
// import m13 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0774.JPG";
// import m14 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0775.JPG";
// import m15 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0807.JPG";
// import m16 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0841.JPG";
// import m17 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0863.JPG";
// import m18 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0868.JPG";
// import m19 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0875.JPG";
// import m20 from "../../assets/images/HomeDesk/events/Mangalya/IMG_4373.JPG";
// import m21 from "../../assets/images/HomeDesk/events/Mangalya/IMG_4391.JPG";
// import m22 from "../../assets/images/HomeDesk/events/Mangalya/Mangalya 2025.JPG";
// import m23 from "../../assets/images/HomeDesk/events/Mangalya/MVI_0361.MP4";

// // ── All data combined ──────────────────────────────────────────────────────
// export const allEventsData = [
//   {
//     id: "Mangalya",
//     order: 1,
//     category: "news",
//     title: "Mangalya 9.0",
//     cardImage: Mangalya,
//     images: [
//       m1,
//       m2,
//       m3,
//       m4,
//       m5,
//       m6,
//       m7,
//       m8,
//       m9,
//       m10,
//       m11,
//       m12,
//       m13,
//       m14,
//       m15,
//       m16,
//       m17,
//       m18,
//       m19,
//       m20,
//       m21,
//       m22,
//     ],
//     pdfs: [],
//     video: [m23],
//     link: "https://youtu.be/8GScjZAb2e8",
//     description: `Mangalya 9.0 started on 28th Feb and 29th Feb 2024 with huge participation.
//     It was inaugurated by Prof.Dr.Nivedita Ekbote coordinator and Prof.Dr.Vijayalaxmi Srinivas,
//     Director of PES Modern Institute of Business Management.
//     The Rocking Flash Mob of our students was the point of attraction at inauguration.
//     Mangalya is the flagship management event of MIBM which consists of management games,
//     sports and most importantly is enormous fun.`,
//     updatedDate: "Updated on 15 April 2024",
//   },
//   {
//     id: "PhD",
//     order: 6,
//     category: "news",
//     title: "Ph.D Interviews",
//     cardImage: null,
//     images: [],
//     pdfs: [PhD],
//     video: null,
//     link: null,
//     description: "",
//     updatedDate: "Updated on 19 May 2023",
//   },
//   {
//     id: "WomensDay",
//     order: 2,
//     category: "news",
//     title: "International Women's Day at MIBM",
//     cardImage: image1,
//     images: [image1, image2],
//     pdfs: [],
//     video: null,
//     link: null,
//     description:
//       "We had entrepreneurs, sportswomen, Chatrapati awardee and founders of Alacrity Gymnastics Academy, Madhura Tambe and Kalyani Tambe. The program started with a beautiful demo of gymnastics of their student and a national player.",
//     updatedDate: "Updated on 8 Mar 2022",
//   },
//   {
//     id: "fee-fixation-2025",
//     category: "notice",
//     order: 8,
//     title: "Fee Fixation Proposal A.Y. 2025-26",
//     cardImage: null,
//     images: [],
//     pdfs: [FRA],
//     video: null,
//     link: null,
//     description: "",
//     updatedDate: "Updated on 28 June 2023",
//   },
//   {
//     id: "orientation-mba-2023",
//     category: "notice",
//     order: 5,
//     title: "Orientation Programme MBA | A.Y 2023-24",
//     cardImage: null,
//     images: [],
//     pdfs: [Orientation],
//     video: null,
//     link: null,
//     description: "",
//     updatedDate: "Updated on 28 June 2023",
//   },
//   {
//     id: "online-registration-2023",
//     category: "notice",
//     order: 10,
//     title: "Online Registration of Application",
//     cardImage: null,
//     images: [],
//     pdfs: [Online_registration],
//     video: null,
//     link: null,
//     blinking: true,
//     description:
//       "Online registration of application and uploading of required documents by the Candidate for admission on the website from 28/06/2023 to 07-07-2023.",
//     updatedDate: "Updated on 28 June 2023",
//   },
//   {
//     id: "admission-enquiry",
//     category: "notice",
//     order: 11,
//     title: "MIBM Admission Enquiry",
//     cardImage: null,
//     images: [],
//     pdfs: [AdmissionEnquiry],
//     video: null,
//     link: null,
//     blinking: true,
//     description: "",
//     updatedDate: "Updated on 14 March 2023",
//   },
//   {
//     id: "admission-brochure-2023",
//     category: "notice",
//     order: 9,
//     title: "MBA Admission Brochure",
//     cardImage: null,
//     images: [],
//     pdfs: [admissionBrochure2],
//     video: null,
//     link: null,
//     blinking: true,
//     description: "",
//     updatedDate: "",
//   },
//   {
//     id: "placement-brochure",
//     category: "event",
//     order: 7,
//     title: "Placement Brochure",
//     cardImage: null,
//     images: [],
//     pdfs: [placementBrochure1],
//     video: null,
//     link: null,
//     description: "",
//     updatedDate: "Upcoming on 27 May 2023",
//     date: 27,
//   },
//   {
//     id: "darpan-2023",
//     order: 3,
//     category: "event",
//     title: "Darpan - Cultural Fest 2023",
//     cardImage: "/assets/images/logo/DARPAN CULTURAL FEST 2025 (1).JPG",
//     images: [
//       d1,
//       d2,
//       d3,
//       d4,
//       d5,
//       d6,
//       d7,
//       d8,
//       d9,
//       d10,
//       d11,
//       d12,
//       d13,
//       d14,
//       d15,
//       d16,
//       d17,
//       d18,
//       d19,
//       d20,
//       d21,
//       d22,
//       d23,
//       d24,
//       d25,
//       d26,
//       d27,
//       d28,
//       d29,
//       d30,
//       d31,
//       d32,
//       d33,
//       d34,
//       d35,
//       d36,
//       d37,
//     ],
//     pdfs: [],
//     video: null,
//     link: null,
//     description:
//       "PES MIBM organizes Darpan - Cultural Fest on Monday, 29th May 2023.",
//     updatedDate: "Upcoming on 29 May 2023",
//     date: 24,
//   },
//   {
//     id: "national-conference-2026",
//     category: "event",
//     order: 4,
//     title: "MIBM National Conference",
//     cardImage: null,
//     images: [],
//     pdfs: [NationalConferences],
//     video: null,
//     link: null,
//     description:
//       'MIBM is organizing 9th National conference on the theme "National Education Policy – Role of Behavioral Sciences in Management and Implementation of Multidisciplinary Education".',
//     updatedDate: "Upcoming on 6 & 7 January 2023",
//     date: "6 & 7",
//   },
// ];

// // ── Constants ──────────────────────────────────────────────────────────────
// const BRAND = "#a70606";

// const categoryConfig = {
//   news: {
//     label: "News",
//     emoji: <AnnouncementIcon sx={{ color: BRAND, fontSize: 50 }} />,
//   },
//   notice: {
//     label: "Notice",
//     emoji: <AssignmentIcon sx={{ color: BRAND, fontSize: 50 }} />,
//   },
//   event: {
//     label: "Event",
//     emoji: <EventIcon sx={{ color: BRAND, fontSize: 50 }} />,
//   },
// };

// // ── Global styles ──────────────────────────────────────────────────────────
// const globalStyles = `
//   @keyframes blinkAnimation {
//     0%   { opacity: 1; }
//     50%  { opacity: 0.2; }
//     100% { opacity: 1; }
//   }

//   @keyframes shimmer {
//     0%   { background-position: -600px 0; }
//     100% { background-position: 600px 0; }
//   }

//   @keyframes fadeIn {
//     from { opacity: 0; transform: translateY(6px); }
//     to   { opacity: 1; transform: translateY(0); }
//   }

//   .skeleton {
//     background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//     background-size: 600px 100%;
//     animation: shimmer 1.4s infinite linear;
//     border-radius: 8px;
//   }

//   .img-fade-in {
//     animation: fadeIn 0.4s ease forwards;
//   }

//   .event-card {
//     transition: transform 0.22s ease, box-shadow 0.22s ease;
//   }
//   .event-card:hover {
//     transform: translateY(-5px);
//     box-shadow: 0 10px 28px rgba(0,0,0,0.15) !important;
//   }
// `;

// // ── LazyImage — skeleton + blur-up + lazy load ─────────────────────────────
// /**
//  * Props:
//  *  src, alt, style, containerStyle, aspectRatio (default "4/3")
//  */
// const LazyImage = ({
//   src,
//   alt,
//   style = {},
//   containerStyle = {},
//   aspectRatio = "auto",
// }) => {
//   const [status, setStatus] = useState("idle"); // idle | loading | loaded | error
//   const imgRef = useRef(null);
//   const observerRef = useRef(null);

//   const startLoad = useCallback(() => {
//     if (status !== "idle") return;
//     setStatus("loading");
//     const img = new Image();
//     img.src = src;
//     img.onload = () => setStatus("loaded");
//     img.onerror = () => setStatus("error");
//   }, [src, status]);

//   useEffect(() => {
//     if (!imgRef.current) return;
//     observerRef.current = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           startLoad();
//           observerRef.current?.disconnect();
//         }
//       },
//       { rootMargin: "300px 0px" }, // preload 300px before entering viewport
//     );
//     observerRef.current.observe(imgRef.current);
//     return () => observerRef.current?.disconnect();
//   }, [startLoad]);

//   return (
//     <div
//       ref={imgRef}
//       style={{
//         position: "relative",
//         overflow: "hidden",
//         aspectRatio,
//         background: "#f0f0f0",
//         borderRadius: style.borderRadius || 0,
//         ...containerStyle,
//       }}
//     >
//       {/* Skeleton shown while idle or loading */}
//       {status !== "loaded" && status !== "error" && (
//         <div
//           className="skeleton"
//           style={{ position: "absolute", inset: 0, borderRadius: 0 }}
//         />
//       )}

//       {/* Error state */}
//       {status === "error" && (
//         <div
//           style={{
//             position: "absolute",
//             inset: 0,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             color: "#bbb",
//             fontSize: 13,
//             flexDirection: "column",
//             gap: 6,
//           }}
//         >
//           <span style={{ fontSize: 26 }}>🖼️</span>
//           <span>Image unavailable</span>
//         </div>
//       )}

//       {/* Actual image — hidden until loaded */}
//       {(status === "loading" || status === "loaded") && (
//         <img
//           src={src}
//           alt={alt}
//           loading="lazy"
//           decoding="async"
//           className={status === "loaded" ? "img-fade-in" : ""}
//           style={{
//             position: "absolute",
//             inset: 0,
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             display: "block",
//             opacity: status === "loaded" ? 1 : 0,
//             transition: "opacity 0.4s ease",
//             filter: status === "loaded" ? "none" : "blur(8px)",
//             ...style,
//           }}
//         />
//       )}
//     </div>
//   );
// };

// // ── CardImage — card-sized lazy image with skeleton ────────────────────────
// const CardImage = ({ src, alt }) => (
//   <LazyImage
//     src={src}
//     alt={alt}
//     aspectRatio="auto"
//     containerStyle={{ height: 145, width: "100%" }}
//     style={{ borderRadius: 0 }}
//   />
// );

// // ── HOME SECTION ───────────────────────────────────────────────────────────
// // export const AllEventsSection = () => {
// //   const navigate = useNavigate();
// //   const [filter, setFilter] = useState("all");

// //   const filtered =
// //     filter === "all"
// //       ? [...allEventsData].sort((a, b) => a.order - b.order)
// //       : allEventsData
// //           .filter((d) => d.category === filter)
// //           .sort((a, b) => a.order - b.order);

// //   return (
// //     <div style={{ padding: "32px 70px" }}>
// //       <style>{globalStyles}</style>

// //       {/* Filter tabs */}
// //       <div
// //         style={{
// //           display: "flex",
// //           gap: 10,
// //           marginBottom: 24,
// //           flexWrap: "wrap",
// //           justifyContent: "center",
// //         }}
// //       >
// //         {["all", "news", "notice", "event"].map((tab) => (
// //           <button
// //             key={tab}
// //             onClick={() => setFilter(tab)}
// //             style={{
// //               padding: "7px 22px",
// //               borderRadius: 20,
// //               border: `2px solid ${BRAND}`,
// //               cursor: "pointer",
// //               fontWeight: 600,
// //               fontSize: 13,
// //               textTransform: "capitalize",
// //               background: filter === tab ? BRAND : "#fff",
// //               color: filter === tab ? "#fff" : BRAND,
// //               transition: "all 0.2s",
// //             }}
// //           >
// //             {tab === "all" ? "All" : categoryConfig[tab].label}
// //           </button>
// //         ))}
// //       </div>

// //       {/* Cards grid */}
// //       <div
// //         style={{
// //           display: "flex",
// //           flexWrap: "wrap",
// //           gap: 20,
// //           justifyContent: "center",
// //         }}
// //       >
// //         {filtered.map((item) => {
// //           const conf = categoryConfig[item.category];
// //           return (
// //             <div
// //               key={item.id}
// //               className="event-card"
// //               onClick={() => navigate(`/EventDetail/${item.id}`)}
// //               style={{
// //                 width: 210,
// //                 borderRadius: 14,
// //                 overflow: "hidden",
// //                 background: "#fff",
// //                 boxShadow: "0 2px 12px rgba(0,0,0,0.09)",
// //                 cursor: "pointer",
// //                 flexShrink: 0,
// //               }}
// //             >
// //               {/* Card image or placeholder */}
// //               {item.cardImage ? (
// //                 <CardImage src={item.cardImage} alt={item.title} />
// //               ) : (
// //                 <div
// //                   style={{
// //                     height: 145,
// //                     background: "transparent",
// //                     border: `1px solid ${BRAND}`,
// //                     borderRadius: 16,
// //                     display: "flex",
// //                     flexDirection: "column",
// //                     alignItems: "center",
// //                     justifyContent: "center",
// //                     gap: 8,
// //                   }}
// //                 >
// //                   <span style={{ fontSize: 44, marginBottom: 20 }}>{conf.emoji}</span>
// //                   {item.pdfs?.length > 0 && (
// //                     <span style={{ color: BRAND, fontSize: 11 }}>PDF</span>
// //                   )}
// //                   {isYouTubeLink(item.link) && (
// //                     <span style={{ color: BRAND, fontSize: 11 }}>Video</span>
// //                   )}
// //                   {!item.pdfs?.length && !isYouTubeLink(item.link) && (
// //                     <span style={{ color: BRAND, fontSize: 11 }}>Click to see</span>
// //                   )}
// //                 </div>
// //               )}

// //               {/* Card content */}
// //               <div style={{ padding: "12px 14px 14px" }}>
// //                 <span
// //                   style={{
// //                     display: "inline-block",
// //                     fontSize: 10,
// //                     fontWeight: 700,
// //                     textTransform: "uppercase",
// //                     letterSpacing: 0.8,
// //                     background: BRAND,
// //                     color: "#fff",
// //                     borderRadius: 4,
// //                     padding: "2px 8px",
// //                     marginBottom: 8,
// //                   }}
// //                 >
// //                   {conf.label}
// //                 </span>

// //                 <p
// //                   style={{
// //                     margin: "0 0 6px",
// //                     fontWeight: 700,
// //                     fontSize: 14,
// //                     color: item.blinking ? BRAND : "#1a1a1a",
// //                     lineHeight: 1.35,
// //                     display: "-webkit-box",
// //                     WebkitLineClamp: 2,
// //                     WebkitBoxOrient: "vertical",
// //                     overflow: "hidden",
// //                     animation: item.blinking ? "blinkAnimation 1s ease-in infinite" : "none",
// //                   }}
// //                 >
// //                   {item.title}
// //                 </p>

// //                 <p style={{ margin: 0, fontSize: 11, color: "#999" }}>
// //                   {item.updatedDate}
// //                 </p>

// //                 <div style={{ marginTop: 10, color: BRAND, fontSize: 12, fontWeight: 600 }}>
// //                   View Details →
// //                 </div>
// //               </div>
// //             </div>
// //           );
// //         })}
// //       </div>
// //     </div>
// //   );
// // };

// export const AllEventsSection = () => {
//   const navigate = useNavigate();

//   // ✅ Logical grouping based on your current data
//   const sections = [
//     {
//       title: "🎓 Value Addition",
//       items: allEventsData.filter((item) =>
//         [
//           "placement-brochure",
//           "admission-brochure-2023",
//           "online-registration-2023",
//           "admission-enquiry",
//         ].includes(item.id),
//       ),
//       bullets: [
//         "Certificate Courses (Excel Skill Development, Six Sigma)",
//         "Foreign Language Programs",
//         "Guest Lectures",
//         "Employability Enhancement Program (Placement Training)",
//       ],
//     },
//     {
//       title: "📊 Research & Presentation",
//       items: allEventsData.filter((item) =>
//         ["national-conference-2023", "PhD"].includes(item.id),
//       ),
//       bullets: [
//         "Research Activities",
//         "Paper Presentations",
//         "Case Study Competitions",
//         "Seminar Presentations",
//       ],
//     },
//     {
//       title: "🎭 Extracurricular Activity",
//       items: allEventsData.filter((item) =>
//         ["Mangalya", "darpan-2023", "WomensDay"].includes(item.id),
//       ),
//       bullets: [
//         "Extra-Curricular Activities",
//         "Darpan",
//         "Mangalya (Flagship Event)",
//         "Funfair",
//         "Days Celebration",
//       ],
//     },
//     {
//       title: "🤝 Social Activities",
//       items: allEventsData.filter((item) =>
//         ["fee-fixation-2025", "orientation-mba-2023"].includes(item.id),
//       ),
//       bullets: [
//         "Social Activities",
//         "Social Activities Club",
//         "We Care Club",
//         "Community Service Initiatives",
//         "Awareness Drives & Social Campaigns",
//       ],
//     },
//   ];

//   return (
//     <div
//       style={{
//         maxWidth: 1200,
//         margin: "0 auto",
//         padding: "32px 20px",
//       }}
//     >
//       <style>{globalStyles}</style>

//       {/* ✅ Grid */}
//       <style>{`
//         .sections-grid {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 60px 40px;
//         }

//         @media (max-width: 768px) {
//           .sections-grid {
//             grid-template-columns: 1fr;
//             gap: 40px;
//           }
//         }
//       `}</style>

//       <div className="sections-grid">
//         {sections.map((section, idx) => (
//           <div key={idx}>
//             {/* Title */}
//             <h2 style={{ marginBottom: 16 }}>{section.title}</h2>

//             {/* Cards */}
//             <div
//               style={{
//                 display: "flex",
//                 flexWrap: "wrap",
//                 gap: 20,
//                 marginBottom: 14,
//               }}
//             >
//               {section.items.map((item) => {
//                 const conf = categoryConfig[item.category];

//                 return (
//                   <div
//                     key={item.id}
//                     className="event-card"
//                     onClick={() => navigate(`/EventDetail/${item.id}`)}
//                     style={{
//                       width: 210,
//                       borderRadius: 14,
//                       overflow: "hidden",
//                       background: "#fff",
//                       boxShadow: "0 2px 12px rgba(0,0,0,0.09)",
//                       cursor: "pointer",
//                     }}
//                   >
//                     {/* Image */}
//                     {item.cardImage ? (
//                       <CardImage src={item.cardImage} alt={item.title} />
//                     ) : (
//                       <div
//                         style={{
//                           height: 145,
//                           border: `1px solid ${BRAND}`,
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {conf.emoji}
//                       </div>
//                     )}

//                     {/* Content */}
//                     <div style={{ padding: "12px 14px" }}>
//                       <span
//                         style={{
//                           display: "inline-block",
//                           fontSize: 10,
//                           fontWeight: 700,
//                           textTransform: "uppercase",
//                           background: BRAND,
//                           color: "#fff",
//                           borderRadius: 4,
//                           padding: "2px 8px",
//                           marginBottom: 6,
//                         }}
//                       >
//                         {conf.label}
//                       </span>

//                       <p
//                         style={{
//                           margin: "0 0 6px",
//                           fontWeight: 700,
//                           fontSize: 14,
//                           lineHeight: 1.35,
//                         }}
//                       >
//                         {item.title}
//                       </p>

//                       <p style={{ margin: 0, fontSize: 11, color: "#999" }}>
//                         {item.updatedDate}
//                       </p>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>

//             {/* Bullets */}
//             <ul style={{ paddingLeft: 18, lineHeight: 1.8 }}>
//               {section.bullets.map((b, i) => (
//                 <li key={i}>{b}</li>
//               ))}
//             </ul>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };
// // ── Helpers ────────────────────────────────────────────────────────────────
// const isYouTubeLink = (url) =>
//   url && (url.includes("youtube.com") || url.includes("youtu.be"));

// const getYouTubeEmbedUrl = (url) => {
//   if (!url) return null;
//   const shortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
//   if (shortMatch) return `https://www.youtube.com/embed/${shortMatch[1]}`;
//   const longMatch = url.match(/[?&]v=([a-zA-Z0-9_-]+)/);
//   if (longMatch) return `https://www.youtube.com/embed/${longMatch[1]}`;
//   return null;
// };

// // ── Section wrapper ────────────────────────────────────────────────────────
// const Section = ({ title, children }) => (
//   <div
//     style={{
//       background: "#fff",
//       borderRadius: 14,
//       padding: 24,
//       marginBottom: 20,
//       boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
//     }}
//   >
//     <h3
//       style={{
//         margin: "0 0 16px",
//         fontSize: 15,
//         fontWeight: 700,
//         color: "#555",
//         textTransform: "uppercase",
//         letterSpacing: 0.5,
//         borderBottom: "2px solid #f0f0f0",
//         paddingBottom: 10,
//       }}
//     >
//       {title}
//     </h3>
//     {children}
//   </div>
// );

// // ── GalleryGrid — virtualized lazy gallery with lightbox ───────────────────
// const GalleryGrid = ({ images, onOpen }) => {
//   // Stagger-load: reveal items progressively as they enter view
//   return (
//     <div
//       style={{
//         display: "grid",
//         gridTemplateColumns:
//           images.length === 1 ? "1fr" : "repeat(auto-fill, minmax(220px, 1fr))",
//         gap: 12,
//       }}
//     >
//       {images.map((img, i) => (
//         <GalleryItem key={i} src={img} index={i} onOpen={onOpen} />
//       ))}
//     </div>
//   );
// };

// const GalleryItem = ({ src, index, onOpen }) => {
//   const [hovered, setHovered] = useState(false);

//   return (
//     <div
//       onClick={() => onOpen(src)}
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//       style={{
//         borderRadius: 10,
//         overflow: "hidden",
//         cursor: "zoom-in",
//         aspectRatio: "4/3",
//         background: "#ddd",
//         // Stagger card reveal based on index
//         animation: `fadeIn 0.35s ease ${Math.min(index * 0.04, 0.6)}s both`,
//       }}
//     >
//       <LazyImage
//         src={src}
//         alt={`Gallery image ${index + 1}`}
//         aspectRatio="4/3"
//         containerStyle={{ height: "100%", width: "100%", borderRadius: 0 }}
//         style={{
//           transform: hovered ? "scale(1.05)" : "scale(1)",
//           transition: "transform 0.3s ease",
//           borderRadius: 0,
//         }}
//       />
//     </div>
//   );
// };

// // ── Lightbox ───────────────────────────────────────────────────────────────
// const Lightbox = ({ images, currentIndex, onClose, onPrev, onNext }) => {
//   const [imgLoaded, setImgLoaded] = useState(false);

//   // Reset loaded state when image changes
//   useEffect(() => {
//     setImgLoaded(false);
//   }, [currentIndex]);

//   // Keyboard navigation
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//       if (e.key === "ArrowRight") onNext();
//       if (e.key === "ArrowLeft") onPrev();
//     };
//     window.addEventListener("keydown", handler);
//     return () => window.removeEventListener("keydown", handler);
//   }, [onClose, onNext, onPrev]);

//   const src = images[currentIndex];
//   const hasMultiple = images.length > 1;

//   return (
//     <div
//       onClick={onClose}
//       style={{
//         position: "fixed",
//         inset: 0,
//         background: "rgba(0,0,0,0.93)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 9999,
//         cursor: "zoom-out",
//         animation: "fadeIn 0.2s ease",
//       }}
//     >
//       {/* Prev button */}
//       {hasMultiple && (
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             onPrev();
//           }}
//           style={navBtnStyle("left")}
//           aria-label="Previous"
//         >
//           ‹
//         </button>
//       )}

//       {/* Image container */}
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           position: "relative",
//           maxWidth: "88vw",
//           maxHeight: "88vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         {/* Skeleton while full image loads */}
//         {!imgLoaded && (
//           <div
//             className="skeleton"
//             style={{ width: "60vw", height: "60vh", borderRadius: 12 }}
//           />
//         )}
//         <img
//           key={src}
//           src={src}
//           alt="full"
//           loading="lazy"
//           decoding="async"
//           onLoad={() => setImgLoaded(true)}
//           style={{
//             maxWidth: "88vw",
//             maxHeight: "88vh",
//             borderRadius: 12,
//             objectFit: "contain",
//             display: imgLoaded ? "block" : "none",
//             animation: imgLoaded ? "fadeIn 0.3s ease" : "none",
//             cursor: "default",
//           }}
//         />

//         {/* Counter */}
//         {hasMultiple && imgLoaded && (
//           <div
//             style={{
//               position: "absolute",
//               bottom: -36,
//               left: "50%",
//               transform: "translateX(-50%)",
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 13,
//               whiteSpace: "nowrap",
//             }}
//           >
//             {currentIndex + 1} / {images.length}
//           </div>
//         )}
//       </div>

//       {/* Next button */}
//       {hasMultiple && (
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             onNext();
//           }}
//           style={navBtnStyle("right")}
//           aria-label="Next"
//         >
//           ›
//         </button>
//       )}

//       {/* Close button */}
//       <button
//         onClick={(e) => {
//           e.stopPropagation();
//           onClose();
//         }}
//         style={{
//           position: "absolute",
//           top: 20,
//           right: 24,
//           background: "rgba(255,255,255,0.15)",
//           border: "none",
//           color: "#fff",
//           fontSize: 26,
//           cursor: "pointer",
//           borderRadius: 8,
//           width: 44,
//           height: 44,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           transition: "background 0.2s",
//         }}
//         onMouseEnter={(e) =>
//           (e.currentTarget.style.background = "rgba(255,255,255,0.28)")
//         }
//         onMouseLeave={(e) =>
//           (e.currentTarget.style.background = "rgba(255,255,255,0.15)")
//         }
//       >
//         ✕
//       </button>
//     </div>
//   );
// };

// const navBtnStyle = (side) => ({
//   position: "absolute",
//   [side]: 16,
//   background: "rgba(255,255,255,0.15)",
//   border: "none",
//   color: "#fff",
//   fontSize: 42,
//   cursor: "pointer",
//   borderRadius: 8,
//   width: 52,
//   height: 52,
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   zIndex: 10,
//   lineHeight: 1,
//   transition: "background 0.2s",
// });

// // ── DETAIL PAGE ────────────────────────────────────────────────────────────
// export const EventDetailPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   // Lightbox state — index-based for prev/next navigation
//   const [lightboxIndex, setLightboxIndex] = useState(null);

//   React.useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [id]);

//   const item = allEventsData.find((d) => d.id === id);
//   const hasYouTube = item ? isYouTubeLink(item.link) : false;
//   const embedUrl = hasYouTube ? getYouTubeEmbedUrl(item.link) : null;

//   const openLightbox = useCallback(
//     (src) => {
//       const idx = item.images.indexOf(src);
//       setLightboxIndex(idx >= 0 ? idx : 0);
//     },
//     [item],
//   );

//   const closeLightbox = useCallback(() => setLightboxIndex(null), []);
//   const prevImage = useCallback(
//     () =>
//       setLightboxIndex(
//         (i) => (i - 1 + item.images.length) % item.images.length,
//       ),
//     [item],
//   );
//   const nextImage = useCallback(
//     () => setLightboxIndex((i) => (i + 1) % item.images.length),
//     [item],
//   );

//   if (!item) {
//     return (
//       <div style={{ textAlign: "center", padding: 80 }}>
//         <h3>Item not found</h3>
//         <button
//           onClick={() => navigate(-1)}
//           style={{
//             padding: "8px 20px",
//             borderRadius: 8,
//             border: "none",
//             background: BRAND,
//             color: "#fff",
//             cursor: "pointer",
//           }}
//         >
//           ← Go Back
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div style={{ background: "#f5f5f5", minHeight: "100vh" }}>
//       <style>{globalStyles}</style>

//       <div className="bredDivMob">
//         <Breadcrumb
//           pageTitle={
//             <h3 className="fs-3 mt-0 text-bold decorated text-light">
//               {item.title}
//             </h3>
//           }
//         />
//       </div>
//       <div className="bredDivDesk">
//         <Breadcrumb
//           pageTitle={
//             <h3 className="fs-3 mt-0 text-bold decorated text-light">
//               {item.title}
//             </h3>
//           }
//         />
//       </div>

//       <div style={{ padding: "16px 40px 0" }}>
//         <button
//           onClick={() => navigate(-1)}
//           style={{
//             background: BRAND,
//             border: "none",
//             color: "#fff",
//             borderRadius: 8,
//             padding: "7px 18px",
//             cursor: "pointer",
//             fontSize: 13,
//             fontWeight: 600,
//             marginLeft: "100px",
//           }}
//         >
//           ← Back
//         </button>
//       </div>

//       <div style={{ maxWidth: 900, margin: "0 auto", padding: "24px 24px" }}>
//         {/* Videos — shows local video AND/OR YouTube, whichever exist */}
//         {(item.video || (hasYouTube && embedUrl)) && (
//           <Section title="Videos">
//             {/* Local video(s) — supports single src or array */}
//             {item.video && (
//               <div style={{ marginBottom: hasYouTube && embedUrl ? 28 : 0 }}>
//                 <p
//                   style={{
//                     margin: "0 0 10px",
//                     fontSize: 12,
//                     fontWeight: 700,
//                     color: "#888",
//                     textTransform: "uppercase",
//                     letterSpacing: 0.6,
//                   }}
//                 >
//                   📹 Event Recording
//                 </p>
//                 {(Array.isArray(item.video) ? item.video : [item.video]).map(
//                   (vid, i) => (
//                     <video
//                       key={i}
//                       controls
//                       style={{
//                         width: "100%",
//                         borderRadius: 12,
//                         background: "#000",
//                         maxHeight: 480,
//                         marginBottom: 12,
//                         display: "block",
//                       }}
//                     >
//                       <source src={vid} type="video/mp4" />
//                       Your browser does not support the video tag.
//                     </video>
//                   ),
//                 )}
//               </div>
//             )}

//             {/* Divider shown only when both exist */}
//             {item.video && hasYouTube && embedUrl && (
//               <div
//                 style={{
//                   borderTop: "2px dashed #f0f0f0",
//                   margin: "4px 0 28px",
//                 }}
//               />
//             )}

//             {/* YouTube embed */}
//             {hasYouTube && embedUrl && (
//               <div>
//                 <p
//                   style={{
//                     margin: "0 0 10px",
//                     fontSize: 12,
//                     fontWeight: 700,
//                     color: "#888",
//                     textTransform: "uppercase",
//                     letterSpacing: 0.6,
//                   }}
//                 >
//                   ▶ YouTube
//                 </p>
//                 <div style={{ borderRadius: 12, overflow: "hidden" }}>
//                   <iframe
//                     width="100%"
//                     height="420"
//                     src={embedUrl}
//                     title={item.title}
//                     frameBorder="0"
//                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                     allowFullScreen
//                     style={{ display: "block" }}
//                   />
//                 </div>
//                 <a
//                   href={item.link}
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     display: "inline-block",
//                     marginTop: 10,
//                     color: BRAND,
//                     fontSize: 13,
//                   }}
//                 >
//                   ▶ Open on YouTube
//                 </a>
//               </div>
//             )}
//           </Section>
//         )}

//         {/* Image Gallery */}
//         {item.images.length > 0 && (
//           <Section title={`Gallery`}>
//             <GalleryGrid images={item.images} onOpen={openLightbox} />
//           </Section>
//         )}

//         {/* Description */}
//         {item.description && (
//           <Section title="About">
//             <p
//               style={{
//                 fontSize: 15,
//                 lineHeight: 1.8,
//                 color: "#333",
//                 margin: 0,
//               }}
//             >
//               {item.description}
//             </p>
//             <p style={{ color: "#a70606" }}>{item.updatedDate ?? item.date}</p>
//           </Section>
//         )}

//         {/* PDF viewer */}
//         {item.pdfs.length > 0 && (
//           <Section title="Documents">
//             {item.pdfs.map((pdf, i) => (
//               <div key={i} style={{ marginBottom: 20 }}>
//                 <div
//                   style={{
//                     borderRadius: 12,
//                     overflow: "hidden",
//                     border: "1px solid #ddd",
//                   }}
//                 >
//                   <iframe
//                     src={pdf}
//                     width="100%"
//                     height="500"
//                     style={{ display: "block", border: "none" }}
//                     title={`Document ${i + 1}`}
//                   />
//                 </div>
//                 <a
//                   href={pdf}
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     display: "inline-block",
//                     marginTop: 10,
//                     background: BRAND,
//                     color: "#fff",
//                     padding: "8px 20px",
//                     borderRadius: 8,
//                     fontSize: 13,
//                     fontWeight: 600,
//                     textDecoration: "none",
//                   }}
//                 >
//                   📄 Open PDF in new tab
//                 </a>
//               </div>
//             ))}
//           </Section>
//         )}

//         {/* External non-YouTube link */}
//         {item.link && !hasYouTube && (
//           <Section title="Link">
//             <a
//               href={item.link}
//               target="_blank"
//               rel="noreferrer"
//               style={{
//                 display: "inline-block",
//                 background: BRAND,
//                 color: "#fff",
//                 padding: "10px 24px",
//                 borderRadius: 8,
//                 fontSize: 14,
//                 fontWeight: 600,
//                 textDecoration: "none",
//               }}
//             >
//               🔗 Visit Link
//             </a>
//           </Section>
//         )}
//       </div>

//       {/* Enhanced Lightbox */}
//       {lightboxIndex !== null && (
//         <Lightbox
//           images={item.images}
//           currentIndex={lightboxIndex}
//           onClose={closeLightbox}
//           onPrev={prevImage}
//           onNext={nextImage}
//         />
//       )}
//     </div>
//   );
// };

//below 3rd code

import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

// ── Import your actual assets ──────────────────────────────────────────────
import Mangalya from "../../assets/images/HomeDesk/events/newsAnnouncement/images/Mangalya.png";
import image1 from "../../assets/images/HomeDesk/events/newsAnnouncement/images/WomensDay-1.jpg";
import image2 from "../../assets/images/HomeDesk/events/newsAnnouncement/images/Womens_Day-2.jpg";
import PhD from "../../assets/pdf/NewsAnnouncement/List of Students selected for PhD Admission 2021-2022.pdf";
import NationalConferences from "../../assets/pdf/UpcomingEvent/MIBM_National_Conference.pdf";
import FRA from "../../assets/pdf/NoticeBoard/FRA Fees Proposal.pdf";
import Orientation from "../../assets/pdf/NoticeBoard/MIBM_Orientation_Program_2023_24.pdf";
import Online_registration from "../../assets/pdf/NoticeBoard/Online_registration_of_application.pdf";
import AdmissionEnquiry from "../../assets/pdf/NoticeBoard/AdmissionEnquiry.pdf";
import AdmissionBrochure from "../../assets/pdf/NoticeBoard/AdmissionBrochoure-2023-24.pdf";
import Breadcrumb from "../../Components/Breadcrumb";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import EventIcon from "@mui/icons-material/Event";
import AssignmentIcon from "@mui/icons-material/Assignment";

import placementBrochure1 from "../../assets/pdf/Event/Final placement brochure.pdf";
import admissionBrochure2 from "../../assets/pdf/Event/MIBM 7 x 7 brochure (1).pdf";

import d1 from "../../assets/images/HomeDesk/events/Darpan/APP_1300.JPG";
import d2 from "../../assets/images/HomeDesk/events/Darpan/APP_1302.JPG";
import d3 from "../../assets/images/HomeDesk/events/Darpan/APP_1303.JPG";
import d4 from "../../assets/images/HomeDesk/events/Darpan/APP_1307.JPG";
import d5 from "../../assets/images/HomeDesk/events/Darpan/APP_1331.JPG";
import d6 from "../../assets/images/HomeDesk/events/Darpan/APP_1335.JPG";
import d7 from "../../assets/images/HomeDesk/events/Darpan/APP_1359.JPG";
import d8 from "../../assets/images/HomeDesk/events/Darpan/APP_1364.JPG";
import d9 from "../../assets/images/HomeDesk/events/Darpan/APP_1393.JPG";
import d10 from "../../assets/images/HomeDesk/events/Darpan/APP_1409.JPG";
import d11 from "../../assets/images/HomeDesk/events/Darpan/APP_1427.JPG";
import d12 from "../../assets/images/HomeDesk/events/Darpan/APP_1433.JPG";
import d13 from "../../assets/images/HomeDesk/events/Darpan/APP_1438.JPG";
import d14 from "../../assets/images/HomeDesk/events/Darpan/APP_1443.JPG";
import d15 from "../../assets/images/HomeDesk/events/Darpan/APP_1460.JPG";
import d16 from "../../assets/images/HomeDesk/events/Darpan/APP_1462.JPG";
import d17 from "../../assets/images/HomeDesk/events/Darpan/APP_1469.JPG";
import d18 from "../../assets/images/HomeDesk/events/Darpan/APP_1493.JPG";
import d19 from "../../assets/images/HomeDesk/events/Darpan/APP_1595.JPG";
import d20 from "../../assets/images/HomeDesk/events/Darpan/APP_1601.JPG";
import d21 from "../../assets/images/HomeDesk/events/Darpan/APP_1605.JPG";
import d22 from "../../assets/images/HomeDesk/events/Darpan/APP_1612.JPG";
import d23 from "../../assets/images/HomeDesk/events/Darpan/APP_1626.JPG";
import d24 from "../../assets/images/HomeDesk/events/Darpan/APP_1643.JPG";
import d25 from "../../assets/images/HomeDesk/events/Darpan/APP_1650.JPG";
import d26 from "../../assets/images/HomeDesk/events/Darpan/APP_1681.JPG";
import d27 from "../../assets/images/HomeDesk/events/Darpan/APP_1689.JPG";
import d28 from "../../assets/images/HomeDesk/events/Darpan/APP_1704.JPG";
import d29 from "../../assets/images/HomeDesk/events/Darpan/APP_1743.JPG";
import d30 from "../../assets/images/HomeDesk/events/Darpan/APP_1748.JPG";
import d31 from "../../assets/images/HomeDesk/events/Darpan/APP_1768.JPG";
import d32 from "../../assets/images/HomeDesk/events/Darpan/APP_1776.JPG";
import d33 from "../../assets/images/HomeDesk/events/Darpan/APP_1777.JPG";
import d34 from "../../assets/images/HomeDesk/events/Darpan/APP_1809.JPG";
import d35 from "../../assets/images/HomeDesk/events/Darpan/APP_1812.JPG";
import d36 from "../../assets/images/HomeDesk/events/Darpan/APP_1822.JPG";
import d37 from "../../assets/images/HomeDesk/events/Darpan/Darpan 2025.JPG";

// ── Mangalya images ────────────────────────────────────────────────────────
import m1 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0325.JPG";
import m2 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0345.JPG";
import m3 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0350.JPG";
import m4 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0394.JPG";
import m5 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0405.JPG";
import m6 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0417.JPG";
import m7 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0522.JPG";
import m8 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0602.JPG";
import m9 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0605.JPG";
import m10 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0611.JPG";
import m11 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0743.JPG";
import m12 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0747.JPG";
import m13 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0774.JPG";
import m14 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0775.JPG";
import m15 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0807.JPG";
import m16 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0841.JPG";
import m17 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0863.JPG";
import m18 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0868.JPG";
import m19 from "../../assets/images/HomeDesk/events/Mangalya/IMG_0875.JPG";
import m20 from "../../assets/images/HomeDesk/events/Mangalya/IMG_4373.JPG";
import m21 from "../../assets/images/HomeDesk/events/Mangalya/IMG_4391.JPG";
import m22 from "../../assets/images/HomeDesk/events/Mangalya/Mangalya 2025.JPG";
import m23 from "../../assets/images/HomeDesk/events/Mangalya/MVI_0361.MP4";

// ── All data combined ──────────────────────────────────────────────────────
export const allEventsData = [
  {
    id: "Mangalya",
    order: 1,
    category: "news",
    title: "Mangalya 9.0",
    cardImage: Mangalya,
    images: [
      m1,
      m2,
      m3,
      m4,
      m5,
      m6,
      m7,
      m8,
      m9,
      m10,
      m11,
      m12,
      m13,
      m14,
      m15,
      m16,
      m17,
      m18,
      m19,
      m20,
      m21,
      m22,
    ],
    pdfs: [],
    video: [m23],
    link: "https://youtu.be/8GScjZAb2e8",
    description: `Mangalya 9.0 started on 28th Feb and 29th Feb 2024 with huge participation. 
    It was inaugurated by Prof.Dr.Nivedita Ekbote coordinator and Prof. Dr. Anamika Singh, 
    Director of PES Modern Institute of Business Management. 
    The Rocking Flash Mob of our students was the point of attraction at inauguration. 
    Mangalya is the flagship management event of MIBM which consists of management games, 
    sports and most importantly is enormous fun.`,
    // updatedDate: "Updated on 15 April 2024",
  },
  {
    id: "PhD",
    order: 6,
    category: "news",
    title: "Ph.D Interviews",
    cardImage: null,
    images: [],
    pdfs: [PhD],
    video: null,
    link: null,
    description: "",
    // updatedDate: "Updated on 19 May 2023",
  },
  {
    id: "WomensDay",
    order: 2,
    category: "news",
    title: "International Women's Day at MIBM",
    cardImage: image1,
    images: [image1, image2],
    pdfs: [],
    video: null,
    link: null,
    description:
      "We had entrepreneurs, sportswomen, Chatrapati awardee and founders of Alacrity Gymnastics Academy, Madhura Tambe and Kalyani Tambe. The program started with a beautiful demo of gymnastics of their student and a national player.",
    // updatedDate: "Updated on 8 Mar 2022",
  },
  {
    id: "fee-fixation-2025",
    category: "notice",
    order: 8,
    title: "Fee Fixation Proposal A.Y. 2025-26",
    cardImage: null,
    images: [],
    pdfs: [FRA],
    video: null,
    link: null,
    description: "",
    // updatedDate: "Updated on 28 June 2023",
  },
  {
    id: "orientation-mba-2023",
    category: "notice",
    order: 5,
    title: "Orientation Programme MBA | A.Y 2025-26",
    cardImage: null,
    images: [],
    pdfs: [Orientation],
    video: null,
    link: null,
    description: "",
    // updatedDate: "Updated on 28 June 2023",
  },
  {
    id: "online-registration-2023",
    category: "notice",
    order: 10,
    title: "Online Registration of Application",
    cardImage: null,
    images: [],
    pdfs: [Online_registration],
    video: null,
    link: null,
    blinking: true,
    description:
      "Online registration of application and uploading of required documents by the Candidate for admission on the website from 28/06/2023 to 07-07-2023.",
    // updatedDate: "Updated on 28 June 2023",
  },
  {
    id: "admission-enquiry",
    category: "notice",
    order: 11,
    title: "MIBM Admission Enquiry",
    cardImage: null,
    images: [],
    pdfs: [AdmissionEnquiry],
    video: null,
    link: null,
    blinking: true,
    description: "",
    // updatedDate: "Updated on 14 March 2023",
  },
  {
    id: "admission-brochure-2023",
    category: "notice",
    order: 9,
    title: "MBA Admission Brochure",
    cardImage: null,
    images: [],
    pdfs: [admissionBrochure2],
    video: null,
    link: null,
    blinking: true,
    description: "",
    updatedDate: "",
  },
  {
    id: "placement-brochure",
    category: "event",
    order: 7,
    title: "Placement Brochure",
    cardImage: null,
    images: [],
    pdfs: [placementBrochure1],
    video: null,
    link: null,
    description: "",
    // updatedDate: "Upcoming on 27 May 2023",
    date: 27,
  },
  {
    id: "darpan-2023",
    order: 3,
    category: "event",
    title: "Darpan - Cultural Fest 2026",
    cardImage: "/assets/images/logo/DARPAN CULTURAL FEST 2025 (1).JPG",
    images: [
      d1,
      d2,
      d3,
      d4,
      d5,
      d6,
      d7,
      d8,
      d9,
      d10,
      d11,
      d12,
      d13,
      d14,
      d15,
      d16,
      d17,
      d18,
      d19,
      d20,
      d21,
      d22,
      d23,
      d24,
      d25,
      d26,
      d27,
      d28,
      d29,
      d30,
      d31,
      d32,
      d33,
      d34,
      d35,
      d36,
      d37,
    ],
    pdfs: [],
    video: null,
    link: null,
    description:
      "PES MIBM organizes Darpan - Cultural Fest on Monday, 29th May 2023.",
    // updatedDate: "Upcoming on 29 May 2023",
    date: 24,
  },
  {
    id: "national-conference-2026",
    category: "event",
    order: 4,
    title: "MIBM National Conference",
    cardImage: null,
    images: [],
    pdfs: [NationalConferences],
    video: null,
    link: null,
    description:
      'MIBM is organizing 9th National conference on the theme "National Education Policy – Role of Behavioral Sciences in Management and Implementation of Multidisciplinary Education".',
    // updatedDate: "Upcoming on 6 & 7 January 2023",
    date: "6 & 7",
  },
];

// ── Constants ──────────────────────────────────────────────────────────────
const BRAND = "#a70606";

const categoryConfig = {
  news: {
    label: "News",
    emoji: <AnnouncementIcon sx={{ color: BRAND, fontSize: 50 }} />,
  },
  notice: {
    label: "Notice",
    emoji: <AssignmentIcon sx={{ color: BRAND, fontSize: 50 }} />,
  },
  event: {
    label: "Event",
    emoji: <EventIcon sx={{ color: BRAND, fontSize: 50 }} />,
  },
};

// ── Global styles ──────────────────────────────────────────────────────────
const globalStyles = `
  @keyframes blinkAnimation {
    0%   { opacity: 1; }
    50%  { opacity: 0.2; }
    100% { opacity: 1; }
  }

  @keyframes shimmer {
    0%   { background-position: -600px 0; }
    100% { background-position: 600px 0; }
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(6px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .skeleton {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 600px 100%;
    animation: shimmer 1.4s infinite linear;
    border-radius: 8px;
  }

  .img-fade-in {
    animation: fadeIn 0.4s ease forwards;
  }

  .slot-card {
    transition: transform 0.22s ease, box-shadow 0.22s ease;
  }
  .slot-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 28px rgba(0,0,0,0.15) !important;
  }

  .bullet-pill {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 8px 16px;
    min-height: 42px;
    border-radius: 50px;
    border: 1.5px solid #e5e5e5;
    background: #fafafa;
    font-size: 13px;
    color: #333;
    font-weight: 500;
    line-height: 1.45;
    list-style: none;
    box-sizing: border-box;
  }

  .bullet-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${BRAND};
    flex-shrink: 0;
    margin-top: 5px;
  }
`;

// ── LazyImage ─────────────────────────────────────────────────────────────
const LazyImage = ({
  src,
  alt,
  style = {},
  containerStyle = {},
  aspectRatio = "auto",
}) => {
  const [status, setStatus] = useState("idle");
  const imgRef = useRef(null);
  const observerRef = useRef(null);

  const startLoad = useCallback(() => {
    if (status !== "idle") return;
    setStatus("loading");
    const img = new Image();
    img.src = src;
    img.onload = () => setStatus("loaded");
    img.onerror = () => setStatus("error");
  }, [src, status]);

  useEffect(() => {
    if (!imgRef.current) return;
    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          startLoad();
          observerRef.current?.disconnect();
        }
      },
      { rootMargin: "300px 0px" },
    );
    observerRef.current.observe(imgRef.current);
    return () => observerRef.current?.disconnect();
  }, [startLoad]);

  return (
    <div
      ref={imgRef}
      style={{
        position: "relative",
        overflow: "hidden",
        aspectRatio,
        background: "#f0f0f0",
        borderRadius: style.borderRadius || 0,
        ...containerStyle,
      }}
    >
      {status !== "loaded" && status !== "error" && (
        <div
          className="skeleton"
          style={{ position: "absolute", inset: 0, borderRadius: 0 }}
        />
      )}
      {status === "error" && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#bbb",
            fontSize: 13,
            flexDirection: "column",
            gap: 6,
          }}
        >
          <span style={{ fontSize: 26 }}>🖼️</span>
          <span>Image unavailable</span>
        </div>
      )}
      {(status === "loading" || status === "loaded") && (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          className={status === "loaded" ? "img-fade-in" : ""}
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            opacity: status === "loaded" ? 1 : 0,
            transition: "opacity 0.4s ease",
            filter: status === "loaded" ? "none" : "blur(8px)",
            ...style,
          }}
        />
      )}
    </div>
  );
};

// ── CardImage ─────────────────────────────────────────────────────────────
const CardImage = ({ src, alt }) => (
  <LazyImage
    src={src}
    alt={alt}
    aspectRatio="auto"
    containerStyle={{ height: "100%", width: "100%" }}
    style={{
      borderRadius: 0,
      objectFit: "cover",
    }}
  />
);

// ── HOME SECTION ──────────────────────────────────────────────────────────
export const AllEventsSection = () => {
  const navigate = useNavigate();

  // const sections = [
  //   {
  //     title: "🎓 Value Addition",
  //     slots: [
  //       { label: "Certification Courses", id: null },
  //       { label: "Foreign Language", id: null },
  //       { label: "Guest Lectures", id: null },
  //       { label: "Employability Enhancement Program", id: null },
  //       { label: "Placement Brochure", id: "placement-brochure" },
  //       { label: "MBA Admission Brochure", id: "admission-brochure-2023" },
  //       { label: "Online Registration", id: "online-registration-2023" },
  //       { label: "Admission Enquiry", id: "admission-enquiry" },
  //     ],
  //   },
  //   {
  //     title: "📊 Research & Presentation",
  //     slots: [
  //       { label: "Research Activities", id: null },
  //       { label: "Paper Presentations", id: null },
  //       { label: "Case Study Competition", id: null },
  //       { label: "Seminar Presentations", id: null },
  //       { label: "MIBM National Conference", id: "national-conference-2026" },
  //       { label: "Ph.D Interviews", id: "PhD" },
  //     ],
  //   },
  //   {
  //     title: "🎭 Extracurricular Activity",
  //     slots: [
  //       { label: "Mangalya 9.0", id: "Mangalya" },
  //       { label: "Darpan - Cultural Fest", id: "darpan-2023" },
  //       { label: "International Women's Day", id: "WomensDay" },
  //       { label: "Fun Fair", id: null },
  //       { label: "Days Celebration", id: null },
  //     ],
  //   },
  //   {
  //     title: "🤝 Social Activities",
  //     slots: [
  //       { label: "Social Activities Club", id: null },
  //       { label: "We Care Club", id: null },
  //       { label: "Community Service Initiatives", id: null },
  //       { label: "Awareness Drives & Social Campaigns", id: null },
  //       { label: "Fee Fixation Proposal", id: "fee-fixation-2025" },
  //       { label: "Orientation Programme MBA", id: "orientation-mba-2023" },
  //     ],
  //   },
  // ];

  const sections = [
    {
      title: "📚 VALUE ADDITION",
      slots: [
        { label: "Guest Lectures", id: null },
        { label: "Foreign Language", id: null },
        { label: "Certification Courses", id: null },
        { label: "Employability Enhancement Program", id: null },
      ],
    },

    {
      title: "🎓 MBA–BBA ADMISSION ENQUIRY",
      slots: [
        { label: "MBA Admission Brochure", id: "admission-brochure-2023" },
        {
          label: "Online Registration of Application",
          id: "online-registration-2023",
        },
        { label: "MIBM Admission Enquiry", id: "admission-enquiry" },
        { label: "Placement Brochure", id: "placement-brochure" },
      ],
    },

    {
      title: "📖 RESEARCH & PRESENTATION",
      slots: [
        { label: "Research Activities", id: null },
        { label: "Paper Presentations", id: null },
        { label: "Ph.D. Interviews", id: "PhD" },
        { label: "Ph.D. Guides", id: null },
        // { label: "Seminar Presentations", id: null },
      ],
    },

    {
      title: "🎭 EXTRACURRICULAR ACTIVITIES",
      slots: [
        { label: "Mangalya 9.0", id: "Mangalya" },
        { label: "Darpan – Cultural Fest 2026", id: "darpan-2023" },
        { label: "Trade Fair", id: null },
        {
          label: "Days Celebration (Women’s Day Celebration)",
          id: "WomensDay",
        },
      ],
    },

    {
      title: "🤝 SOCIAL ACTIVITIES",
      slots: [
        { label: "Social Activities Club", id: null },
        { label: "We Care Club", id: null },
        { label: "Community Service Initiatives", id: null },
        { label: "Awareness Drives & Social Campaigns", id: null },
      ],
    },

    {
      title: "📌 OTHER",
      slots: [
        {
          label: "Fee Fixation Proposal A.Y. 2025–26",
          id: "fee-fixation-2025",
        },
        {
          label: "Orientation Programme MBA | A.Y. 2025–26",
          id: "orientation-mba-2023",
        },
        { label: "MIBM National Conference", id: "national-conference-2026" },
        { label: "Case study Competition", id: null },
      ],
    },
  ];
  return (
    <div style={{ width: "100%", boxSizing: "border-box" }}>
      <style>{globalStyles}</style>
      <style>{`
    .sections-grid {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 56px;
  padding: 50px 10px;
  margin: 30px auto;
  box-sizing: border-box;
  width: calc(100% - 60px);
  max-width: 1500px;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.06);
}
    .section-block {
  width: 100%;
  max-width: 1240px; /* optional */
  margin: 0 auto;
}
        .slots-wrap {
  display: grid;
  grid-template-columns: repeat(4, 270px);
  gap: 28px;
  margin-bottom: 24px;
  justify-content: center;
}
       .slot-card {
           width: 270px;
  min-width: 270px;
  max-width: 270px;
  flex: 0 0 220px;

          display: flex;              /* ✅ important */
          flex-direction: column;     /* ✅ stack children */

          border-radius: 14px;
          overflow: hidden;
          background: #fff;
          box-shadow: 0 2px 12px rgba(0,0,0,0.09);
          cursor: pointer;
          transition: transform 0.22s ease, box-shadow 0.22s ease;

          height: 290px;              /* ✅ force equal height */
        }   
        .slot-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 28px rgba(0,0,0,0.15);
        }
        .bullets-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0 auto;
  padding: 0;
  list-style: none;
  width: 100%;
  max-width: 1164px; /* 4 cards width + gaps */
}
        .bullet-pill {
          min-height: 42px;
        }
        @media (max-width: 1100px) {
          .sections-grid { padding: 32px 32px; gap: 40px 40px; }
          .slot-card { width: 130px; min-width: 130px; max-width: 130px; flex: 0 0 130px; }
        }
   @media (max-width: 768px) {
  .sections-grid {
    padding: 24px 16px;
  }

  .slots-wrap {
    grid-template-columns: repeat(2, 1fr);
  }

  .bullets-list {
    max-width: 100%;
  }

  .slot-card {
    width: 100%;
    min-width: unset;
    max-width: unset;
  }
}
      `}</style>

      <div className="sections-grid">
        {sections.map((section, idx) => (
          <div key={idx} className="section-block">
            {/* Section heading */}
            <h2
              style={{
                marginBottom: 18,
                marginTop: 0,
                fontSize: 24,
                fontWeight: 800,
                color: "#1a1a1a",
                textAlign: "left",
              }}
            >
              {section.title}
            </h2>

            {/* Cards row */}
            <div className="slots-wrap">
              {section.slots.map((slot, si) => {
                const item = slot.id
                  ? allEventsData.find((d) => d.id === slot.id)
                  : null;
                const hasData = !!item;
                const conf = hasData
                  ? categoryConfig[item.category]
                  : categoryConfig["event"];

                const handleClick = () => {
                  // Always navigate — detail page handles "no data" gracefully
                  if (hasData) {
                    navigate(`/EventDetail/${slot.id}`);
                  } else {
                    navigate(`/EventDetail/__nodata__`);
                  }
                };

                return (
                  <div
                    key={si}
                    className="slot-card"
                    onClick={handleClick}
                    style={{ cursor: "pointer" }}
                  >
                    {/* ── Image/Icon area (FIXED SAME HEIGHT) ── */}
                    <div
                      style={{
                        height: 190,
                        width: "100%",
                        flexShrink: 0,
                        position: "relative",
                      }}
                    >
                      {hasData && item.cardImage ? (
                        <CardImage src={item.cardImage} alt={item.title} />
                      ) : (
                        <div
                          style={{
                            height: "100%",
                            width: "100%",
                            border: `1px solid ${BRAND}`,
                            borderRadius: "13px 13px 0 0",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 6,
                            background: "transparent",
                            boxSizing: "border-box", // ✅ IMPORTANT
                          }}
                        >
                          {conf.emoji}
                          {hasData && item.pdfs?.length > 0 && (
                            <span style={{ color: BRAND, fontSize: 11 }}>
                              PDF
                            </span>
                          )}
                        </div>
                      )}
                    </div>

                    {/* ── Content area ── */}
                    <div style={{ padding: "12px 14px 14px" }}>
                      <span
                        style={{
                          display: "inline-block",
                          fontSize: 10,
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: 0.8,
                          background: BRAND,
                          color: "#fff",
                          borderRadius: 4,
                          padding: "2px 8px",
                          marginBottom: 8,
                        }}
                      >
                        {hasData ? conf.label : "Soon"}
                      </span>

                      <p
                        style={{
                          margin: "0 0 6px",
                          fontWeight: 700,
                          fontSize: 15,
                          textAlign: "center",
                          color: hasData && item.blinking ? BRAND : "#1a1a1a",
                          lineHeight: 1.35,
                          // display: "-webkit-box",
                          // WebkitLineClamp: 2,
                          // WebkitBoxOrient: "vertical",
                          // overflow: "hidden",
                          animation:
                            hasData && item.blinking
                              ? "blinkAnimation 1s ease-in infinite"
                              : "none",
                        }}
                      >
                        {hasData ? item.title : slot.label}
                      </p>

                      {/* <div
                        style={{
                          marginTop: 10,
                          color: BRAND,
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                      >
                        View Details →
                      </div> */}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* ── Rounded bullet list ── */}
            {/* <ul className="bullets-list">
              {section.slots.map((slot, si) => {
                const item = slot.id
                  ? allEventsData.find((d) => d.id === slot.id)
                  : null;
                const label = item ? item.title : slot.label;
                return (
                  <li key={si} className="bullet-pill">
                    <span />
                    {label}
                  </li>
                );
              })}
            </ul> */}
          </div>
        ))}
      </div>
    </div>
  );
};

// ── Helpers ────────────────────────────────────────────────────────────────
const isYouTubeLink = (url) =>
  url && (url.includes("youtube.com") || url.includes("youtu.be"));

const getYouTubeEmbedUrl = (url) => {
  if (!url) return null;
  const shortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
  if (shortMatch) return `https://www.youtube.com/embed/${shortMatch[1]}`;
  const longMatch = url.match(/[?&]v=([a-zA-Z0-9_-]+)/);
  if (longMatch) return `https://www.youtube.com/embed/${longMatch[1]}`;
  return null;
};

// ── Section wrapper ────────────────────────────────────────────────────────
const Section = ({ title, children }) => (
  <div
    style={{
      background: "#fff",
      borderRadius: 14,
      padding: 24,
      marginBottom: 20,
      boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
    }}
  >
    <h3
      style={{
        margin: "0 0 16px",
        fontSize: 15,
        fontWeight: 700,
        color: "#555",
        textTransform: "uppercase",
        letterSpacing: 0.5,
        borderBottom: "2px solid #f0f0f0",
        paddingBottom: 10,
      }}
    >
      {title}
    </h3>
    {children}
  </div>
);

// ── GalleryGrid ────────────────────────────────────────────────────────────
const GalleryGrid = ({ images, onOpen }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns:
        images.length === 1 ? "1fr" : "repeat(auto-fill, minmax(220px, 1fr))",
      gap: 12,
    }}
  >
    {images.map((img, i) => (
      <GalleryItem key={i} src={img} index={i} onOpen={onOpen} />
    ))}
  </div>
);

const GalleryItem = ({ src, index, onOpen }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onClick={() => onOpen(src)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        borderRadius: 10,
        overflow: "hidden",
        cursor: "zoom-in",
        aspectRatio: "4/3",
        background: "#ddd",
        animation: `fadeIn 0.35s ease ${Math.min(index * 0.04, 0.6)}s both`,
      }}
    >
      <LazyImage
        src={src}
        alt={`Gallery image ${index + 1}`}
        aspectRatio="4/3"
        containerStyle={{ height: "100%", width: "100%", borderRadius: 0 }}
        style={{
          transform: hovered ? "scale(1.05)" : "scale(1)",
          transition: "transform 0.3s ease",
          borderRadius: 0,
        }}
      />
    </div>
  );
};

// ── Lightbox ───────────────────────────────────────────────────────────────
const Lightbox = ({ images, currentIndex, onClose, onPrev, onNext }) => {
  const [imgLoaded, setImgLoaded] = useState(false);

  useEffect(() => {
    setImgLoaded(false);
  }, [currentIndex]);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNext();
      if (e.key === "ArrowLeft") onPrev();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose, onNext, onPrev]);

  const src = images[currentIndex];
  const hasMultiple = images.length > 1;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.93)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        cursor: "zoom-out",
        animation: "fadeIn 0.2s ease",
      }}
    >
      {hasMultiple && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onPrev();
          }}
          style={navBtnStyle("left")}
          aria-label="Previous"
        >
          ‹
        </button>
      )}
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          maxWidth: "88vw",
          maxHeight: "88vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {!imgLoaded && (
          <div
            className="skeleton"
            style={{ width: "60vw", height: "60vh", borderRadius: 12 }}
          />
        )}
        <img
          key={src}
          src={src}
          alt="full"
          loading="lazy"
          decoding="async"
          onLoad={() => setImgLoaded(true)}
          style={{
            maxWidth: "88vw",
            maxHeight: "88vh",
            borderRadius: 12,
            objectFit: "contain",
            display: imgLoaded ? "block" : "none",
            animation: imgLoaded ? "fadeIn 0.3s ease" : "none",
            cursor: "default",
          }}
        />
        {hasMultiple && imgLoaded && (
          <div
            style={{
              position: "absolute",
              bottom: -36,
              left: "50%",
              transform: "translateX(-50%)",
              color: "rgba(255,255,255,0.7)",
              fontSize: 13,
              whiteSpace: "nowrap",
            }}
          >
            {currentIndex + 1} / {images.length}
          </div>
        )}
      </div>
      {hasMultiple && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onNext();
          }}
          style={navBtnStyle("right")}
          aria-label="Next"
        >
          ›
        </button>
      )}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        style={{
          position: "absolute",
          top: 20,
          right: 24,
          background: "rgba(255,255,255,0.15)",
          border: "none",
          color: "#fff",
          fontSize: 26,
          cursor: "pointer",
          borderRadius: 8,
          width: 44,
          height: 44,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "background 0.2s",
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.background = "rgba(255,255,255,0.28)")
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.background = "rgba(255,255,255,0.15)")
        }
      >
        ✕
      </button>
    </div>
  );
};

const navBtnStyle = (side) => ({
  position: "absolute",
  [side]: 16,
  background: "rgba(255,255,255,0.15)",
  border: "none",
  color: "#fff",
  fontSize: 42,
  cursor: "pointer",
  borderRadius: 8,
  width: 52,
  height: 52,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 10,
  lineHeight: 1,
  transition: "background 0.2s",
});

// ── DETAIL PAGE ────────────────────────────────────────────────────────────
export const EventDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  const item = allEventsData.find((d) => d.id === id);
  const hasYouTube = item ? isYouTubeLink(item.link) : false;
  const embedUrl = hasYouTube ? getYouTubeEmbedUrl(item.link) : null;

  const openLightbox = useCallback(
    (src) => {
      const idx = item.images.indexOf(src);
      setLightboxIndex(idx >= 0 ? idx : 0);
    },
    [item],
  );
  const closeLightbox = useCallback(() => setLightboxIndex(null), []);
  const prevImage = useCallback(
    () =>
      setLightboxIndex(
        (i) => (i - 1 + item.images.length) % item.images.length,
      ),
    [item],
  );
  const nextImage = useCallback(
    () => setLightboxIndex((i) => (i + 1) % item.images.length),
    [item],
  );

  // ── No data ──
  if (!item) {
    return (
      <div style={{ background: "#f5f5f5", minHeight: "100vh" }}>
        <div className="bredDivMob">
          <Breadcrumb
            pageTitle={
              <h3 className="fs-3 mt-0 text-bold decorated text-light">
                Not Found
              </h3>
            }
          />
        </div>
        <div className="bredDivDesk">
          <Breadcrumb
            pageTitle={
              <h3 className="fs-3 mt-0 text-bold decorated text-light">
                Not Found
              </h3>
            }
          />
        </div>
        <div style={{ padding: isMobile ? "12px 16px" : "16px 40px 0" }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              background: BRAND,
              border: "none",
              color: "#fff",
              borderRadius: 8,
              padding: isMobile ? "6px 14px" : "7px 18px",
              cursor: "pointer",
              fontSize: isMobile ? 12 : 13,
              fontWeight: 600,
              marginLeft: isMobile ? 0 : "100px",
            }}
          >
            ← Back
          </button>
        </div>
        <div
          style={{
            maxWidth: 480,
            margin: "60px auto",
            textAlign: "center",
            background: "#fff",
            borderRadius: 16,
            padding: "48px 32px",
            boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
          }}
        >
          <div style={{ fontSize: 60, marginBottom: 16 }}>📭</div>
          <h2 style={{ color: "#1a1a1a", marginBottom: 10, fontSize: 22 }}>
            No Data Found
          </h2>
          <p style={{ color: "#888", fontSize: 14, lineHeight: 1.7 }}>
            Content for this section is not available yet.
            <br />
            Please check back later.
          </p>
          <button
            onClick={() => navigate(-1)}
            style={{
              marginTop: 24,
              background: BRAND,
              border: "none",
              color: "#fff",
              borderRadius: 8,
              padding: "9px 28px",
              cursor: "pointer",
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            ← Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: "#f5f5f5", minHeight: "100vh" }}>
      <style>{globalStyles}</style>

      <div className="bredDivMob">
        <Breadcrumb
          pageTitle={
            <h3 className="fs-3 mt-0 text-bold decorated text-light">
              {item.title}
            </h3>
          }
        />
      </div>
      <div className="bredDivDesk">
        <Breadcrumb
          pageTitle={
            <h3 className="fs-3 mt-0 text-bold decorated text-light">
              {item.title}
            </h3>
          }
        />
      </div>

      <div style={{ padding: isMobile ? "12px 16px" : "16px 40px 0" }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: BRAND,
            border: "none",
            color: "#fff",
            borderRadius: 8,
            padding: isMobile ? "6px 14px" : "7px 18px",
            cursor: "pointer",
            fontSize: isMobile ? 12 : 13,
            fontWeight: 600,
            marginLeft: isMobile ? 0 : "100px",
          }}
        >
          ← Back
        </button>
      </div>

      <div
        style={{
          maxWidth: 900,
          margin: "0 auto",
          padding: isMobile ? "16px" : "24px 24px",
        }}
      >
        {/* Videos */}
        {(item.video || (hasYouTube && embedUrl)) && (
          <Section title="Videos">
            {item.video && (
              <div style={{ marginBottom: hasYouTube && embedUrl ? 28 : 0 }}>
                <p
                  style={{
                    margin: "0 0 10px",
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#888",
                    textTransform: "uppercase",
                    letterSpacing: 0.6,
                  }}
                >
                  📹 Event Recording
                </p>
                {(Array.isArray(item.video) ? item.video : [item.video]).map(
                  (vid, i) => (
                    <video
                      key={i}
                      controls
                      style={{
                        width: "100%",
                        borderRadius: 12,
                        background: "#000",
                        maxHeight: isMobile ? 240 : 480,
                        marginBottom: 12,
                        display: "block",
                      }}
                    >
                      <source src={vid} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ),
                )}
              </div>
            )}
            {item.video && hasYouTube && embedUrl && (
              <div
                style={{
                  borderTop: "2px dashed #f0f0f0",
                  margin: "4px 0 28px",
                }}
              />
            )}
            {hasYouTube && embedUrl && (
              <div>
                <p
                  style={{
                    margin: "0 0 10px",
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#888",
                    textTransform: "uppercase",
                    letterSpacing: 0.6,
                  }}
                >
                  ▶ YouTube
                </p>
                <div style={{ borderRadius: 12, overflow: "hidden" }}>
                  <iframe
                    width="100%"
                    height={isMobile ? "220" : "420"}
                    src={embedUrl}
                    title={item.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ display: "block" }}
                  />
                </div>
                <a
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "inline-block",
                    marginTop: 10,
                    color: BRAND,
                    fontSize: 13,
                  }}
                >
                  ▶ Open on YouTube
                </a>
              </div>
            )}
          </Section>
        )}

        {/* Gallery */}
        {item.images.length > 0 && (
          <Section title="Gallery">
            <GalleryGrid images={item.images} onOpen={openLightbox} />
          </Section>
        )}

        {/* Description */}
        {item.description && (
          <Section title="About">
            <p
              style={{
                fontSize: isMobile ? 14 : 15,
                lineHeight: 1.8,
                color: "#333",
                margin: 0,
              }}
            >
              {item.description}
            </p>
            <p style={{ color: BRAND }}>{item.updatedDate ?? item.date}</p>
          </Section>
        )}

        {/* PDFs */}
        {item.pdfs.length > 0 && (
          <Section title="Documents">
            {item.pdfs.map((pdf, i) => (
              <div key={i} style={{ marginBottom: 20 }}>
                <div
                  style={{
                    borderRadius: 12,
                    overflow: "hidden",
                    border: "1px solid #ddd",
                  }}
                >
                  <iframe
                    src={pdf}
                    width="100%"
                    height={isMobile ? "350" : "500"}
                    style={{ display: "block", border: "none" }}
                    title={`Document ${i + 1}`}
                  />
                </div>
                <a
                  href={pdf}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "inline-block",
                    marginTop: 10,
                    background: BRAND,
                    color: "#fff",
                    padding: "8px 20px",
                    borderRadius: 8,
                    fontSize: 13,
                    fontWeight: 600,
                    textDecoration: "none",
                  }}
                >
                  📄 Open PDF in new tab
                </a>
              </div>
            ))}
          </Section>
        )}

        {/* External non-YouTube link */}
        {item.link && !hasYouTube && (
          <Section title="Link">
            <a
              href={item.link}
              target="_blank"
              rel="noreferrer"
              style={{
                display: "inline-block",
                background: BRAND,
                color: "#fff",
                padding: "10px 24px",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              🔗 Visit Link
            </a>
          </Section>
        )}
      </div>

      {lightboxIndex !== null && (
        <Lightbox
          images={item.images}
          currentIndex={lightboxIndex}
          onClose={closeLightbox}
          onPrev={prevImage}
          onNext={nextImage}
        />
      )}
    </div>
  );
};
